import React, { Component } from "react";
import { Redirect, Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { CSVLink } from "react-csv";
import { Form } from "react-bootstrap";
// import Moment from 'react-moment';
import "moment-timezone";
import { format } from "date-fns";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
// import ReactHtmlParser from 'react-html-parser';

import { URL_IMG } from "../../configs/urlConfigs";
import {
  ROUTE_REFRESH,
  ROUTE_AFFILIATE_REFRESH,
  ROUTE_CLIENT_REFRESH,
  PAGENUMROWS_AFFILIATE,
  PAGING_END_INDEX,
  LOGIN_SUPER_ADMIN_GROUP,
  LOGIN_AFFILIATE_GROUP,
  LOGIN_CLIENT_GROUP,
  SEARCH_TEXT_COUNT,
  EVENT_STATUS,
  ROUTE_AFFILIATE_CLIENT_PROFILE,
  TAB1,
  TAB2,
  TAB3,
  TAB4,
  TAB5,
  TAB6,
  TAB7,
  QUOTE_STATUS,
  QUOTE_SENT,
  ROUTE_AFFILIATE_SCHEDULE_SHIFT,
  EVENT_STATUS_COMPLETED,
  EVENT_STATUS_INVOICED
} from "../../configs/staticConfigs";
import {
  MSG_CANCEL_EVENT_CONFIRM,
  MSG_REQUIRED,
  MSG_NOT_FOUND,
  MSG_NOT_GENERATED,
  MSG_QUOTE_UPDATE,
  MSG_QUOTE_DELETE,
  MSG_QUOTE_CANCELLED,
  MSG_EVENT_COMPLETE_SUCCESS,
  MSG_EVENT_COMPLETE_ERROR,
  MSG_CONFIRM_ACCEPT_QUOTE,
  MSG_CONFIRM_ACCEPT_QUOTE_AFLT,
  MSG_DATA_SAVE_ERROR,
  MSG_EVENT_ADD_ERROR,
  MSG_CONFIRM_SEND_QUOTE,
  MSG_CONFIRM_SEND_INVOICE,
  MSG_CSV_DOWNLOAD_ERROR,
  MSG_FILE_SIZE_ERROR,
  MSG_LOGO_FORMAT,
  MSG_PO_SIGN_REQ,
} from "../../configs/msgConfigs";
import {
  LBL_APP_NAME,
  LBL_EVENT,
  LBL_EVENTS,
  LBL_QUOTE,
  LBL_QUOTES,
  LBL_CLEAR_FILTERS,
  LBL_FILTER,
  LBL_ADD_EVENT,
  LBL_EDIT_EVENT,
  LBL_PLUS_NEW_QUOTE,
  LBL_CONFIRM_EVENT_COMPLETE,
  LBL_REQUEST_QUOTE,
  LBL_ACCEPT_QUOTE,
  LBL_REJECT_QUOTE,
  LBL_EDIT,
  LBL_COMPLETE,
  LBL_CANCEL,
  LBL_SEND_QUOTE,
  LBL_SEND_INVOICE, LBL_RESEND_INVOICE,
  LBL_EXPORT_INVOICE,
  LBL_INVOICE,
  LBL_SLNUM,
  LBL_EVENT_TITLE,
  LBL_AFFILIATE,
  LBL_LOCATION,
  LBL_CLIENT,
  LBL_EVENT_STATUS,
  LBL_TEAM_COUNT,
  LBL_SHIFT_COUNT,
  LBL_PO,
  LBL_SCHEDULE,
  LBL_QUOTE_NO,
  LBL_LIST_VIEW,
  LBL_CALENDAR_VIEW,
  LBL_DOWNLOAD,
  LBL_INVICE_EXPORT,
  LBL_SELECT,
  LBL_SCHEDULE_SHIFT,
  LBL_ADD_NEW_CLIENT_CONTACT,
  LBL_CONFIRM_REJECT_QUOTE,
  LBL_CONFIRM_SEND_QUOTE_REQUEST,
  LBL_SEND_QUOTE_REQUEST_NOTE,
  LBL_TIME_CHANGE_REQUEST,
  LBL_TIME_CHANGE_REQUEST_CLIENT,
  LBL_CONFIRM_DELETE,
  LBL_Total_COST,
  LBL_CURRENCY_POUND,
  FILE_CSVDOWNLOAD_QUOTES,
  FILE_CSVDOWNLOAD_EVENTS,
  LBL_DECLINE
} from "../../configs/labelConfigs";

import * as types from "../../actions";
import { validateEventAddAction } from "../../actions/validateActions";
import { clientContactListAction } from "../../actions/clientActions";
import {
  clearAction,
  fromDashboard,
  serverTimeAction,
} from "../../actions/commonActions";
import {
  cancelReasonsListAction,
  listInvoiceAction,
  listEventMessagesAction,
  eventListAction,
  eventClientListAction,
  eventAddAction,
  quoteEventLocationListAction,
  eventEditAction,
  eventUpdateAction,
  eventDeleteAction,
  eventQuoteSummaryAction,
  quoteAcceptAction,
  quoteRejectAction,
  eventClientAffiliateListAction,
  quoteRequestAction,
  quoteSendtoClientAction,
  invoiceSendtoClientAction,
  quoteDownloadAction,
  invoiceDownloadAction,
  eventSummaryAction,
  eventClientDetailsAction,
  eventUserLogsListAction,
  eventCancelAction,
  eventPopupIdResetAction,
  eventCompleteAction,
  eventListDownloadAction,
  invoiceListDownloadAction,
  listEventShiftsAction,
  sendShiftIdsForScheduleAction,
} from "../../actions/eventActions";
import { aflt_departmentsListAction } from "../../actions/settings/affiliates/aflt_departmentActions";

import {
  showRequestQuoteBtn,
  showSendQuoteBtn,
  showSendInvoiceBtn,
  showAcceptRejectQuoteBtn,
  showAcceptRejectQuoteBtnAflt,
  showDownloadQuoteBtn,
  showEventCancelBtn,
  checkEventNotCancelled,
  showScheduleBtn,
  showCompleteEventBtn,
} from "./eventStatusCheck";

import { getSortClass } from "../../utils/commonUtilities";
import {
  userGroupUrlCheck,
  getUserTimeZone,
} from "../../utils/userGroupUrlCheck";
import { checkPermissions } from "../../utils/permissions";
import { getUserGroupData, setStorage } from "../../utils/browserStorage";
import { formValid, imageExtension, fileSize } from "../../utils/validation";
import { appendVenueLoc, converDateToLocal } from "../../utils/commonUtilities";

import EventAdd from "./eventAdd";
import ShiftAdd from "./shiftAdd";
import EventDetails from "./eventDetails";
import Toast from "../commons/helpers/toast";
import FilterQuote from "./filters/filterEvent";
import Filter from "../commons/helpers/filterBy";
import EventCalendarView from "./eventCalendarView";
import Paginator from "../commons/helpers/paginator";
import ModalWindow from "../commons/helpers/modalWindow";
import ClientContactAdd from "../client/tabContent/clientContactAdd";
import ShiftDetailSlider from "./shiftDetailSlider";

import * as gLoc from "../../configs/googleConfigs";
import { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import CustomModalHeaderStepper from "./customModalHeaderStepper";

class EventList extends Component {
  constructor(props) {
    super(props);

    let isEvent = 0;
    if (this.props.location.pathname.includes("quotes")) {
      isEvent = 0;
    } else if (this.props.location.pathname.includes("events")) {
      isEvent = 1;
    }

    let date = new Date();
    // Add a day
    date = format(new Date(date.setDate(date.getDate() + 1)), "yyyy-MM-dd");
    this.state = {
      cancelReasonId: "",
      hrefEventId: this.props.match.params.id,
      hrefEventIdUsed: 0,
      profileCurrency: "",
      activePage: 1,
      startIndex: 0,
      endIndex: PAGING_END_INDEX,
      activeRowId: 0,
      perPageCount: PAGENUMROWS_AFFILIATE,
      sortField: "start_date",
      sortOrder: "",
      isFilterOn: false,
      toastMessage: "",
      toastFlag: false,
      toastSuccess: true,
      searchQuote: "",
      formErrors: {
        affiliateId: "",
        clientId: MSG_REQUIRED,
        clientContactId: MSG_REQUIRED,
        eventTitle: MSG_REQUIRED,
        locationId: MSG_REQUIRED,
        city: "",
        state: "",
        country: "",
        postcode: "",
        startDate: "",
        endDate: "",
        startTime: "",
        endTime: "",
        acceptQuotePONumber: "",
      },
      eventData: {
        affiliateId: null,
        clientId: null,
        clientContactId: null,
        eventTitle: null,
        quoteNumber: "",
        locationId: null,
        location: "",
        googleLocation: "",
        venue: "",
        streetOne: "",
        streetTwo: "",
        city: null,
        state: null,
        country: null,
        postcode: null,
        startDate: date,
        endDate: date,
        startTime: "00:00",
        endTime: "23:59",
        poNumber: "",
        noLocationFound: false,
        eventNotes: "",
        status: "",
        created_by: "",
      },
      profileId: "",
      assuserId: "",
      eventStatus: EVENT_STATUS,
      quoteStatus: QUOTE_STATUS,
      eventId: "",
      eventDeleteTitle: "",
      eventDataForShift: {
        eventId: "",
        eventTitle: "",
        clientId: "",
        affiliateId: "",
        location: "",
        venueName: "",
        streetOne: "",
        streetTwo: "",
        city: "",
        state: "",
        country: "",
        postcode: "",
        startDate: "",
        endDate: "",
        googleLocation: ""
      },
      eventIdSelected: "",
      isClientPage: false,
      isSuperAdminPage: false,
      locGoogleCodes: {
        streetOne: "",
        streetTwo: "",
        city: "",
        state: "",
        country: "",
        postcode: "",
      },
      disableLocationSearch: false,
      eventActionTitle: LBL_ADD_EVENT,
      fileType: "0",
      isListLayout: true,
      isEvent: isEvent,
      activeTab: TAB1,
      userGroup: 0,
      filterClicked: 0,
      resetFilterClicked: 0,
      applyFilterClicked: 0,
      applyFilter: 0,
      filtersData: {},
      resetGoogleLocation: 0,
      chkGoogleLocation: 0,
      validationMsgArr: [],
      completeEventId: 0,
      loadPreviewQuoteEventId: 0,
      acceptQuotePONumber: "",
      popUpModal: false,
      eventSelOption: [],
      newClientContactAdded: 0,
      addContactClicked: 0,
      saveFormDataClicked: 0,
      exportQuote: [],
      exportInvoiceData: [],
      reloadCalendarView: 0,
      signature: "",
      isSignatureValid: true,
      signatureLabel: "",
      signatureUrl: "",
      labelValidation: "",
      saveSignature: false,
      initialValidation: false,
      sameAsProfileSign: true,
      activeShiftId: 0,
      defaultStartDate: date,
    };

    this.onShowActionButtons = this.onShowActionButtons.bind(this);
    this.onHideActionButtons = this.onHideActionButtons.bind(this);
    this.openModal = this.openModal.bind(this);
    this.onHandleChange = this.onHandleChange.bind(this);
    this.setToasterState = this.setToasterState.bind(this);
    this.quoteOrInvoice = this.quoteOrInvoice.bind(this);
    this.modalQuoteDelete = React.createRef();
    this.contactModal = React.createRef();
    this.shiftRef = React.createRef();
    this.modalEventCancel = React.createRef();
    this.modalQuote = React.createRef();
    this.modalAcceptQuoteWithPO = React.createRef();
    this.modalAcceptQuote = React.createRef();
    this.modalSendQuote = React.createRef();
    this.modalRejectQuote = React.createRef();
    this.modalRequestQuote = React.createRef();
    this.modalEventComplete = React.createRef();
  }

  onCSVDownload = () => {
    this.props.eventListDownloadAction({
      isEvent: this.state.isEvent,
      pageSize: 0,
      page: 0,
      column: this.state.sortOrder + this.state.sortField,
      search: this.state.searchQuote,
      applyFilter: this.state.applyFilter,
      filtersData: this.state.filtersData,
      csvDownload: 1,
    });
  };

  onInvoiceCSVDownload = () => {
    this.props.invoiceListDownloadAction({
      isEvent: this.state.isEvent,
      pageSize: 0,
      page: 0,
      column: this.state.sortOrder + this.state.sortField,
      search: this.state.searchQuote,
      applyFilter: this.state.applyFilter,
      filtersData: this.state.filtersData,
      csvDownload: 1,
    });
  };

  onEventInvoiceCSVDownload = (event_id) => {
    this.props.invoiceListDownloadAction({
      event_id: event_id,
      csvDownload: 1,
    });
  };

  openAddClientContact = (eventClientId) => {
    let addContactClicked = this.state.addContactClicked + 1;
    this.setState({ addContactClicked: addContactClicked }, () => {
      this.contactModal.current.handleOpenModal();
      setTimeout(() => {
        let contactModalPop = document.getElementById("contactModalPop");
        if (contactModalPop) {
          contactModalPop.style.width = "650px";
        }
      }, 500);
    });
  };

  onSaveFormClientContactData = (e) => {
    let saveFormDataClicked = this.state.saveFormDataClicked + 1;
    this.setState({ saveFormDataClicked });
  };

  onModalClientContactFormReset = () => { };

  refreshParent = () => {
    let newClientContactAdded = this.state.newClientContactAdded + 1;
    this.setState({ newClientContactAdded }, () => {
      this.contactModal.current.handleModelClose();
    });
  };

  onCloseToastPop = () => {
    // USED FOR POPUP clientContactAdd
    this.setState({ toastFlag: false, toastMessage: "", toastSuccess: false });
  };

  setToasterStatePop = (isEnabled, message, isSucces, isAutoHide = true) => {
    this.setState({
      toastFlag: isEnabled,
      toastMessage: message,
      toastSuccess: isSucces,
    });
    if (isAutoHide) {
      setTimeout(() => {
        this.onCloseToastPop();
      }, 3000);
    }
  };

  scheduleShiftClick = (eventId) => {
    this.props.history.push(ROUTE_AFFILIATE_SCHEDULE_SHIFT + "/" + eventId);
  };

  scheduleShift = (eventId, shiftData, goToScheduleAfterTimeChangeAccept) => {
    if (shiftData && goToScheduleAfterTimeChangeAccept) {
      let shiftItems = [];
      shiftItems = [{
        start_datetime: shiftData.start_datetime,
        end_datetime: shiftData.end_datetime,
        skills: shiftData.shift_skills,
        shiftId: shiftData.id,
        chiefsRequired: shiftData.chiefs_required,
        chiefsPending: shiftData.chiefs_pending,
        isAllChecked: false,
        status: shiftData.status,
        department: shiftData.department !== null ? shiftData.department.id : ''
      }];
      this.props.sendShiftIdsForScheduleAction(shiftItems);
      this.props.history.push(ROUTE_AFFILIATE_SCHEDULE_SHIFT + '/' + eventId);
    }
  }

  callEventDetailsWithPreviewQuote = (eventId) => {
    if (eventId) {
      this.setState({ loadPreviewQuoteEventId: eventId }, () => {
        this.showQuoteDetails(eventId);
      });
    }
  };

  onEventCompletion = (eventId) => {
    this.setState({ completeEventId: eventId }, () => {
      this.modalEventComplete.current.handleOpenModal();
    });
  };

  onEventCompleteAction = () => {
    let eventId = this.state.completeEventId;
    this.props.eventCompleteAction(eventId);
    this.modalEventComplete.current.handleModelClose();
  };

  onEventDetailsClose = () => {
    this.props.eventPopupIdResetAction("");
    this.setState({ eventIdSelected: "", activeTab: TAB1 });
  };

  onResetFiltersButton = () => {
    let resetFilterClicked = this.state.resetFilterClicked + 1;
    if (this.state.applyFilter > 0) {
      this.setState(
        {
          resetFilterClicked,
          applyFilter: 0,
          filtersData: {},
          activePage: 1,
          sortOrder: "",
          sortField: "start_date",
        },
        () => {
          this.props.eventListAction({
            isEvent: this.state.isEvent,
            pageSize: this.state.perPageCount,
            page: this.state.activePage,
            column: this.state.sortOrder + this.state.sortField,
            search: this.state.searchQuote,
          });

          if (this.state.isFilterOn) {
            document.getElementById("filterIcon").classList.add("active");
          } else if (!this.state.isFilterOn) {
            document.getElementById("filterIcon").classList.remove("active");
          }
        }
      );
    } else {
      this.setState({ resetFilterClicked, applyFilter: 0 });
    }
    if (this.props.dashboardActionRequired) {
      let { filtersData } = this.state;
      filtersData.quoteStatIds = [2];
      filtersData.filtersSelected = 1;
      filtersData.selDateType = 1;

      this.setState({
        applyFilter: 1,
        applyFilterClicked: 0,
        filtersData: filtersData,
      });
      this.applyFilters(filtersData);
    }
  };

  onApplyFilterButton = () => {
    let applyFilterClicked = this.state.applyFilterClicked + 1;
    this.setState({ applyFilterClicked });
  };

  applyFilters = (filtersData) => {
    // RESET ALL LISTING VALUES TO DEFAULT AND ADD FILTER FLAG AND FILTER DATA
    let filterApplied = 0;
    if (filtersData.filtersSelected > 0) filterApplied = 1;
    let sortOrder = "";
    let sortField = "start_date";
    if (filtersData.selectedStartDate !== 0) sortField = "start_date";
    this.setState(
      {
        activePage: 1,
        sortOrder: sortOrder,
        sortField: sortField,
        searchShift: "",
        applyFilter: filterApplied,
        filtersData: filtersData,
      },
      () => {
        if (this.state.isListLayout) {
          this.props.eventListAction({
            isEvent: this.state.isEvent,
            pageSize: this.state.perPageCount,
            page: this.state.activePage,
            column: this.state.sortOrder + this.state.sortField,
            search: "",
            applyFilter: filterApplied,
            filtersData: filtersData,
          });
        } else {
          let cView = this.state.reloadCalendarView + 1;
          this.setState({ reloadCalendarView: cView });
        }
      }
    );
  };

  openModal = () => {
    let { eventData, isClientPage, profileId, formErrors } = this.state;
    this.modalQuote.current.handleOpenModal();
    if (!isClientPage) {
      this.props.validateEventAddAction();
      eventData["affiliateId"] = profileId;
      this.props.eventClientListAction({
        pageSize: 0,
        page: 0,
        column: "-id",
        search: "",
      });
    } else {
      let storageData = getUserGroupData("client");
      eventData["affiliateId"] = storageData.client_default_affiliate_id;
      eventData["clientId"] = profileId;
      formErrors["clientId"] = "";
      this.props.eventClientAffiliateListAction(profileId);
      this.props.clientContactListAction({
        clientId: Number(profileId),
        column: "-id",
      });
    }
    this.setState({ eventActionTitle: LBL_ADD_EVENT, eventData, formErrors });
  };
  refreshClientList = () => {
    this.props.eventClientListAction({
      pageSize: 0,
      page: 0,
      column: "-id",
      search: "",
    });
  };
  onHandleChange = (e) => {
    let { signatureLabel, signatureValid, signatureUrl, labelValidation } =
      this.state;
    const { name } = e.target;

    let value = e.target.type === "file" ? e.target.files[0] : e.target.value;
    let trimmedValue = "";
    if (e.target.type === "text") {
      trimmedValue = value.trim();
    }

    let { formErrors, eventData, acceptQuotePONumber, signature } = this.state;

    switch (name) {
      case "affiliateId":
        eventData[name] = value;
        formErrors.affiliateId =
          value.length <= 0 || Number(value) === 0 ? MSG_REQUIRED : "";
        break;
      case "eventTitle":
        eventData[name] = value;
        formErrors.eventTitle = trimmedValue.length <= 0 ? MSG_REQUIRED : "";
        break;
      case "acceptQuotePONumber":
        acceptQuotePONumber = trimmedValue;
        formErrors.acceptQuotePONumber =
          trimmedValue.length <= 0 ? MSG_REQUIRED : "";
        labelValidation = trimmedValue.length > 0 ? "" : labelValidation;
        break;
      case "signature":
        if (!fileSize(value.size)) {
          signatureLabel = MSG_FILE_SIZE_ERROR;
          signatureValid = false;
        }
        if (!imageExtension(value.name)) {
          signatureLabel = MSG_LOGO_FORMAT; // MSG_FILE_FORMAT_ERROR;
          signatureValid = false;
        }
        break;
      default:
        eventData[name] = value;
        break;
    }
    if (name === "signature" && signatureLabel === "") {
      signature = value;
      signatureUrl = URL.createObjectURL(e.target.files[0]);
      labelValidation = "";
    }

    this.setState({
      formErrors,
      eventData,
      acceptQuotePONumber,
      signature,
      signatureValid,
      signatureLabel,
      signatureUrl,
      labelValidation,
    });
  };

  handleClientContactChange = (selectedContact) => {
    let { eventData, formErrors } = this.state;
    if (selectedContact.length > 0) {
      eventData["clientContactId"] = selectedContact[0].id;
      formErrors["clientContactId"] = "";
    } else {
      formErrors["clientContactId"] = MSG_REQUIRED;
    }
    this.setState({ eventData, formErrors });
  };

  handleClientChange = (selectedClient) => {
    let { eventData, formErrors } = this.state;
    if (selectedClient.length > 0) {
      eventData["clientId"] = selectedClient[0].id;
      formErrors["clientId"] = "";
      eventData["clientContactId"] = null;
      this.props.clientContactListAction({
        clientId: selectedClient[0].id,
        column: "-id",
      });
    } else {
      formErrors["clientId"] = MSG_REQUIRED;
    }
    this.setState({ eventData, formErrors });
  };

  handleRemoveContact = () => {
    let { eventData } = this.state;
    eventData["clientContactId"] = null;
    this.setState({ eventData });
  };

  handleRemoveClient = () => {
    let { eventData } = this.state;
    eventData["clientContactId"] = null;
    eventData["clientId"] = null;
    this.setState({ eventData });
  };

  onShowActionButtons = (event, rowId) => {
    let dropdown = document.getElementById("dropdown-" + rowId);
    let dropdownMenu = document.getElementById("dropdown-menu-" + rowId);
    dropdown.classList.toggle("show");
    dropdownMenu.classList.toggle("show");
    if (this.state.activeRowId === 0) {
      this.setState({ activeRowId: rowId });
      document.getElementById("img-action-" + rowId).focus();
    } else if (this.state.activeRowId === rowId) {
      this.setState({ activeRowId: 0 });
    } else if (this.state.activeRowId !== rowId) {
      dropdown = document.getElementById("dropdown-" + this.state.activeRowId);
      dropdownMenu = document.getElementById(
        "dropdown-menu-" + this.state.activeRowId
      );
      dropdown.classList.toggle("show");
      dropdownMenu.classList.toggle("show");
      this.setState({ activeRowId: rowId });
      document.getElementById("img-action-" + rowId).focus();
    }
  };

  onHideActionButtons = (event, rowId) => {
    let dropdown = document.getElementById("dropdown-" + rowId);
    let dropdownMenu = document.getElementById("dropdown-menu-" + rowId);
    dropdown.classList.remove("show");
    dropdownMenu.classList.remove("show");
    this.setState({ activeRowId: 0 });
  };

  eventEditBtnClick = (eventId, clientId) => {
    let { isClientPage, profileId } = this.state;
    this.modalQuote.current.handleOpenModal();
    if (!isClientPage) {
      this.props.clientContactListAction({ clientId: clientId, column: "-id" });
      this.props.eventClientListAction({
        pageSize: 0,
        page: 0,
        column: "-id",
        search: "",
      });
    } else {
      this.props.eventClientAffiliateListAction(profileId);
      this.props.clientContactListAction({
        clientId: Number(profileId),
        column: "-id",
      });
    }
    this.props.eventEditAction(eventId);
    this.setState({ eventActionTitle: LBL_EDIT_EVENT });
  };

  // deleteBtnClick = (rowId,title) =>{
  //     this.setState({
  //         eventId:rowId,
  //         eventDeleteTitle:title
  //     });
  //     this.modalQuoteDelete.current.handleOpenModal();
  // }

  openQuoteAcceptModalWithPO = (eventId, PONum) => {
    let formErrors = this.state.formErrors;
    formErrors["acceptQuotePONumber"] =
      PONum && PONum.length > 0 ? "" : MSG_REQUIRED;
    this.setState({ eventId: eventId, acceptQuotePONumber: PONum, formErrors });
    this.modalAcceptQuoteWithPO.current.handleOpenModal();
  };

  onAcceptActionWithPO = () => {
    let dataObj = {
      eventId: this.state.eventId,
      po_number: this.state.acceptQuotePONumber,
    };
    this.props.quoteAcceptAction(dataObj);
    this.modalAcceptQuoteWithPO.current.handleModelClose();
  };

  openQuoteAcceptModal = (eventId) => {
    let formErrors = this.state.formErrors;
    formErrors["acceptQuotePONumber"] = "";
    this.setState({
      eventId: eventId,
      formErrors,
    });
    this.modalAcceptQuote.current.handleOpenModal();
  };

  saveSign = (e) => {
    this.setState({
      saveSignature: e.target.checked,
    });
  };

  onAcceptAction = (e) => {
    e.preventDefault();
    const data = new FormData();
    if (
      this.state.acceptQuotePONumber.trim().length === 0 &&
      !this.state.signature
    ) {
      let { formErrors, labelValidation } = this.state;
      formErrors.acceptQuotePONumber = MSG_REQUIRED;
      labelValidation = MSG_PO_SIGN_REQ;
      this.setState({ formErrors, labelValidation });
    } else {
      let dataObj = {
        eventId: this.state.eventId,
        po_number: this.state.acceptQuotePONumber,
        signature: this.state.signature,
        save_signature: this.state.saveSignature,
      };
      data.append("eventId", this.state.eventId);
      data.append("po_number", this.state.acceptQuotePONumber);
      data.append("signature", this.state.signature);
      data.append("save_signature", this.state.saveSignature);
      this.props.quoteAcceptAction(data);
      this.setState({ saveSignature: false });
      this.modalAcceptQuote.current.handleModelClose();
    }
  };

  openRejectQuoteModal = (eventId) => {
    this.setState({
      eventId: eventId,
    });
    this.modalRejectQuote.current.handleOpenModal();
  };

  onRejectQuoteAction = () => {
    let eventId = this.state.eventId;
    this.props.quoteRejectAction(eventId);
    this.modalRejectQuote.current.handleModelClose();
  };

  openRequestQuoteModal = (eventId) => {
    this.setState({
      eventId: eventId,
    });
    this.modalRequestQuote.current.handleOpenModal();
  };

  onRequestQuoteAction = () => {
    let eventId = this.state.eventId;
    this.props.quoteRequestAction(eventId);
    this.modalRequestQuote.current.handleModelClose();
  };

  openSendQuoteModal = (eventId, fileType) => {
    this.setState(
      {
        eventId: eventId,
        fileType: fileType,
      },
      () => {
        this.modalSendQuote.current.handleOpenModal();
      }
    );
  };

  onSendQuoteAction = () => {
    let eventId = this.state.eventId;
    if (Number(this.state.fileType) > 0) {
      this.props.invoiceSendtoClientAction(eventId);
    } else {
      // if(this.state.fileType==="0")
      this.props.quoteSendtoClientAction(eventId);
    }
    this.modalSendQuote.current.handleModelClose();
  };

  openEventCancelModal = (eventId) => {
    this.setState({
      eventId: eventId,
    });
    this.modalEventCancel.current.handleOpenModal();
  };

  onCancelAction = () => {
    if (this.state.cancelReasonId) {
      let eventId = this.state.eventId;
      this.props.eventCancelAction({
        eventId: eventId,
        cancelReasonId: this.state.cancelReasonId,
      });
      this.modalEventCancel.current.handleModelClose();
    }
  };

  onDeleteAction = () => {
    let eventId = this.state.eventId;
    this.props.eventDeleteAction(eventId);
    this.modalQuoteDelete.current.handleModelClose();
  };

  onPagePrevious = (e) => {
    const { startIndex, endIndex } = this.state;
    let previousPage = startIndex + 1 - PAGING_END_INDEX;
    if (this.state.applyFilter > 0) {
      this.props.eventListAction({
        isEvent: this.state.isEvent,
        pageSize: this.state.perPageCount,
        page: previousPage,
        column: this.state.sortOrder + this.state.sortField,
        search: this.state.searchQuote,
        applyFilter: 1,
        filtersData: this.state.filtersData,
      });
    } else {
      this.props.eventListAction({
        isEvent: this.state.isEvent,
        pageSize: this.state.perPageCount,
        page: previousPage,
        column: this.state.sortOrder + this.state.sortField,
        search: this.state.searchQuote,
      });
    }
    if (startIndex === 0) {
      this.setState({
        activePage: previousPage,
        startIndex: startIndex,
        endIndex: endIndex,
      });
    } else {
      this.setState({
        activePage: previousPage,
        startIndex: startIndex - PAGING_END_INDEX,
        endIndex: endIndex - PAGING_END_INDEX,
      });
    }
  };

  onPageUp = (e) => {
    if (this.state.applyFilter > 0) {
      this.props.eventListAction({
        isEvent: this.state.isEvent,
        pageSize: this.state.perPageCount,
        page: e.target.id,
        column: this.state.sortOrder + this.state.sortField,
        search: this.state.searchQuote,
        applyFilter: 1,
        filtersData: this.state.filtersData,
      });
    } else {
      this.props.eventListAction({
        isEvent: this.state.isEvent,
        pageSize: this.state.perPageCount,
        page: e.target.id,
        column: this.state.sortOrder + this.state.sortField,
        search: this.state.searchQuote,
      });
    }
    this.setState({
      activePage: Number(e.target.id),
    });
  };

  onPageNext = (e) => {
    const { startIndex, endIndex } = this.state;
    const { totalPage } = this.props;

    let nextPage = startIndex + 1 + PAGING_END_INDEX;
    if (this.state.applyFilter > 0) {
      this.props.eventListAction({
        isEvent: this.state.isEvent,
        pageSize: this.state.perPageCount,
        page: nextPage,
        column: this.state.sortOrder + this.state.sortField,
        search: this.state.searchQuote,
        applyFilter: 1,
        filtersData: this.state.filtersData,
      });
    } else {
      this.props.eventListAction({
        isEvent: this.state.isEvent,
        pageSize: this.state.perPageCount,
        page: nextPage,
        column: this.state.sortOrder + this.state.sortField,
        search: this.state.searchQuote,
      });
    }

    if (endIndex === totalPage || totalPage <= PAGING_END_INDEX) {
      this.setState({
        activePage: nextPage,
        startIndex: startIndex,
        endIndex: endIndex,
      });
    } else {
      this.setState({
        activePage: nextPage,
        startIndex: startIndex + PAGING_END_INDEX,
        endIndex: endIndex + PAGING_END_INDEX,
      });
    }
  };

  onSort = (event, sortKey) => {
    let sOrder = "";
    if (this.state.sortField === sortKey) {
      sOrder = this.state.sortOrder === "-" ? "" : "-";
      if (this.state.applyFilter > 0) {
        this.props.eventListAction({
          isEvent: this.state.isEvent,
          pageSize: this.state.perPageCount,
          page: this.state.activePage,
          column: sOrder + this.state.sortField,
          search: this.state.searchQuote,
          applyFilter: 1,
          filtersData: this.state.filtersData,
        });
      } else {
        this.props.eventListAction({
          isEvent: this.state.isEvent,
          pageSize: this.state.perPageCount,
          page: this.state.activePage,
          column: sOrder + this.state.sortField,
          search: this.state.searchQuote,
        });
      }
      this.setState({ sortOrder: sOrder });
    } else {
      this.setState({ sortField: sortKey });
      if (this.state.applyFilter > 0) {
        this.props.eventListAction({
          isEvent: this.state.isEvent,
          pageSize: this.state.perPageCount,
          page: this.state.activePage,
          column: this.state.sortOrder + sortKey,
          search: this.state.searchQuote,
          applyFilter: 1,
          filtersData: this.state.filtersData,
        });
      } else {
        this.props.eventListAction({
          isEvent: this.state.isEvent,
          pageSize: this.state.perPageCount,
          page: this.state.activePage,
          column: this.state.sortOrder + sortKey,
          search: this.state.searchQuote,
        });
      }
    }
  };

  onModalFormReset = () => {
    let date = this.state.defaultStartDate;
    let userGroupData = userGroupUrlCheck(this.props.location);
    let userGroup = "";
    let profileId = "";
    let affiliateId = null;
    if (userGroupData !== undefined) {
      userGroup = userGroupData.user_group;
      profileId = userGroupData.profile_id;
    }
    if (userGroup === LOGIN_AFFILIATE_GROUP) {
      affiliateId = Number(profileId);
    } else if (userGroup === LOGIN_CLIENT_GROUP) {
      affiliateId = Number(userGroupData.client_default_affiliate_id);
    }
    // Add a day
    this.setState({
      eventData: {
        affiliateId: affiliateId,
        clientId: this.state.isClientPage ? profileId : null,
        clientContactId: null,
        eventTitle: null,
        quoteNumber: "",
        locationId: null,
        location: "",
        googleLocation: "",
        venue: "",
        streetOne: "",
        streetTwo: "",
        city: null,
        state: null,
        country: null,
        postcode: null,
        startDate: date,
        endDate: date,
        startTime: "00:00",
        endTime: "23:59",
        poNumber: "",
        noLocationFound: false,
        eventNotes: "",
        created_by: "",
      },
      formErrors: {
        affiliateId: "",
        clientId: this.state.isClientPage ? "" : MSG_REQUIRED,
        clientContactId: MSG_REQUIRED,
        eventTitle: MSG_REQUIRED,
        locationId: MSG_REQUIRED,
        city: "",
        state: "",
        country: "",
        postcode: "",
        startDate: "",
        endDate: "",
        startTime: "",
        endTime: "",
        acceptQuotePONumber: "",
      },
      eventId: "",
      eventDeleteTitle: "",
      disableLocationSearch: false,
      acceptQuotePONumber: "",
      cancelReasonId: "",
      initialValidation: false,
    });
  };

  googleLocSelect = (address) => {
    let { eventData, formErrors } = this.state;
    let locGoogleCodes = this.state.locGoogleCodes;

    geocodeByAddress(address)
      .then((results) => {
        eventData.streetOne = "";
        eventData.streetTwo = "";
        eventData.city = "";
        eventData.state = "";
        eventData.country = "";
        eventData.postcode = "";
        eventData.location = results[0].formatted_address;
        let tmpArr = [];
        tmpArr = address.split(",");
        eventData.venue = tmpArr[0];

        locGoogleCodes.streetOne = "";
        locGoogleCodes.streetTwo = "";
        locGoogleCodes.city = "";
        locGoogleCodes.state = "";
        locGoogleCodes.country = "";
        locGoogleCodes.postcode = "";

        let allAddress = results[0].address_components;
        let addrTypes = [];
        let foundVar = 0;
        let tmpVal = "";
        allAddress.forEach((element) => {
          addrTypes = element.types;
          foundVar = 0;
          addrTypes.forEach((item) => {
            tmpVal = element.long_name.trim().length
              ? element.long_name.trim()
              : element.short_name.trim().length
                ? element.short_name.trim()
                : "";
            if (foundVar === 0 && tmpVal !== "") {
              if (gLoc.GOOGLE_LOCATION_STREET.includes(item)) {
                foundVar = 1;
                if (eventData["streetOne"].trim() === "")
                  eventData["streetOne"] = tmpVal;
                else eventData["streetOne"] += ", " + tmpVal;

                if (locGoogleCodes["streetOne"].trim() === "")
                  locGoogleCodes["streetOne"] = item;
                else locGoogleCodes["streetOne"] += ", " + item;
              } else if (gLoc.GOOGLE_LOCATION_STREET2.includes(item)) {
                foundVar = 1;
                if (eventData["streetTwo"].trim() === "")
                  eventData["streetTwo"] = tmpVal;
                else eventData["streetTwo"] += ", " + tmpVal;
                if (locGoogleCodes["streetTwo"].trim() === "")
                  locGoogleCodes["streetTwo"] = item;
                else locGoogleCodes["streetTwo"] += ", " + item;
              } else if (gLoc.GOOGLE_LOCATION_CITY.includes(item)) {
                foundVar = 1;
                if (eventData["city"].trim() === "") eventData["city"] = tmpVal;
                else eventData["city"] += ", " + tmpVal;
                if (locGoogleCodes["city"].trim() === "")
                  locGoogleCodes["city"] = item;
                else locGoogleCodes["city"] += ", " + item;
              } else if (gLoc.GOOGLE_LOCATION_STATE.includes(item)) {
                foundVar = 1;
                if (eventData["state"].trim() === "")
                  eventData["state"] = tmpVal;
                else eventData["state"] += ", " + tmpVal;
                if (locGoogleCodes["state"].trim() === "")
                  locGoogleCodes["state"] = item;
                else locGoogleCodes["state"] += ", " + item;
              } else if (gLoc.GOOGLE_LOCATION_COUNTRY.includes(item)) {
                foundVar = 1;
                if (eventData["country"].trim() === "")
                  eventData["country"] = tmpVal;
                else eventData["country"] += ", " + tmpVal;
                if (locGoogleCodes["country"].trim() === "")
                  locGoogleCodes["country"] = item;
                else locGoogleCodes["country"] += ", " + item;
              } else if (gLoc.GOOGLE_LOCATION_POSTCODE.includes(item)) {
                foundVar = 1;
                if (eventData["postcode"].trim() === "")
                  eventData["postcode"] = tmpVal;
                else eventData["postcode"] += ", " + tmpVal;
                if (locGoogleCodes["postcode"].trim() === "")
                  locGoogleCodes["postcode"] = item;
                else locGoogleCodes["postcode"] += ", " + item;
              }
            }
          });
        });

        getLatLng(results[0]).then((latLng) => {
          eventData["googleLocation"] = latLng.lat + "," + latLng.lng;
        });
      })
      .then(() => {
        formErrors["city"] = "";
        formErrors["state"] = "";
        formErrors["country"] = "";
        formErrors["postcode"] = "";
        formErrors["locationId"] = "";
        this.setState({
          eventData: eventData,
          locGoogleCodes: locGoogleCodes,
          formErrors,
        });
      })
      .catch((error) => console.error("Error", error));
  };

  onGetGoogleLoc = (e) => {
    let resetGoogleLocation = this.state.resetGoogleLocation;
    if (e.target.checked) {
      resetGoogleLocation++;
    }

    const { name } = e.target;
    let { eventData } = this.state;
    eventData[name] = e.target.checked;
    // const instance = this._typeahead.getInstance()
    // instance.clear();
    eventData["locationId"] = "";
    eventData["venue"] = "";
    eventData["googleLocation"] = "";
    eventData["streetOne"] = "";
    eventData["streetTwo"] = "";
    eventData["city"] = null;
    eventData["state"] = null;
    eventData["country"] = null;
    eventData["postcode"] = null;
    this.setState({ eventData, resetGoogleLocation });
  };

  resetFormErrors = () => { };

  onCloseToast = () => {
    this.setState({ toastFlag: false, toastMessage: "", toastSuccess: false });
  };

  onSearchQuote = (e) => {
    let sVal = e.target.value;
    this.setState({ searchQuote: sVal }, () => {
      if (String(sVal).length >= 3 || String(sVal).length === 0) {
        this.props.eventListAction({
          isEvent: this.state.isEvent,
          pageSize: this.state.perPageCount,
          page: String(sVal).length > 0 ? 1 : this.state.activePage,
          column: this.state.sortOrder + this.state.sortField,
          search: this.state.searchQuote,
          applyFilter: this.state.applyFilter,
          filtersData: this.state.filtersData,
        });
      }
    });
  };

  setToasterState(isEnabled, message, isSucces, autoHide = true) {
    this.setState({
      toastFlag: isEnabled,
      toastMessage: message,
      toastSuccess: isSucces,
    });
    if (autoHide) {
      setTimeout(() => {
        this.onCloseToast();
      }, 5000);
    }
  }

  onSaveFormData = () => {
    let { eventData, assuserId, formErrors, eventId, isClientPage, initialValidation } =
      this.state;

    let timeZone = getUserTimeZone(this.props.location);
    let timeZoneOffSet = timeZone.utc_offset;
    if (formValid(this.state) && this.startAndEndTimeDifference()) {
      let locationData = {};
      let data = {};
      if (!eventData.locationId || eventData.locationId === "") {
        let locName = appendVenueLoc(eventData.location, eventData.venue);
        locationData = {
          location: locName ? locName : "",
          venue: eventData.venue === null ? "" : eventData.venue,
          street1: eventData.streetOne === null ? "" : eventData.streetOne,
          street2: eventData.streetTwo === null ? "" : eventData.streetTwo,
          city: eventData.city === null ? "" : eventData.city,
          state: eventData.state === null ? "" : eventData.state,
          country: eventData.country === null ? "" : eventData.country,
          postcode: eventData.postcode === null ? "" : eventData.postcode,
          lat_long:
            eventData.googleLocation === null ? "" : eventData.googleLocation,
        };

        // start_date:format(new Date(eventData.startDate),"yyyy-MM-dd'T'HH:mm:ss.SSSxxx"),
        // end_date:format(new Date(eventData.endDate),"yyyy-MM-dd'T'HH:mm:ss.SSSxxx"),
        data = {
          title: eventData.eventTitle,
          client_profile: parseInt(eventData.clientId, 10),
          client_contact: parseInt(eventData.clientContactId, 10),
          location_data: locationData,
          start_date:
            format(
              new Date(eventData.startDate.substring(0, 10) + " 00:00:00"),
              "yyyy-MM-dd"
            ) +
            "T" +
            eventData.startTime +
            ":00" +
            "+00:00",
          end_date:
            format(
              new Date(eventData.endDate.substring(0, 10) + " 00:00:00"),
              "yyyy-MM-dd"
            ) +
            "T" +
            eventData.endTime +
            ":00" +
            "+00:00",
          start_time: eventData.startTime,
          end_time: eventData.endTime,
          ...(isClientPage === false && { affiliate_id: assuserId }),
          affiliate_profile: parseInt(eventData.affiliateId, 10),
          notes: eventData.eventNotes,
        };
      } else {
        // start_date:format(new Date(eventData.startDate),"yyyy-MM-dd'T'HH:mm:ss.SSSxxx"),
        // end_date:format(new Date(eventData.endDate),"yyyy-MM-dd'T'HH:mm:ss.SSSxxx"),
        data = {
          title: eventData.eventTitle,
          client_profile: parseInt(eventData.clientId, 10),
          client_contact: parseInt(eventData.clientContactId, 10),
          location: eventData.locationId,
          start_date:
            format(
              new Date(eventData.startDate.substring(0, 10) + " 00:00:00"),
              "yyyy-MM-dd"
            ) +
            "T" +
            eventData.startTime +
            ":00" +
            "+00:00",
          end_date:
            format(
              new Date(eventData.endDate.substring(0, 10) + " 00:00:00"),
              "yyyy-MM-dd"
            ) +
            "T" +
            eventData.endTime +
            ":00" +
            "+00:00",
          start_time: eventData.startTime,
          end_time: eventData.endTime,
          ...(isClientPage === false && { affiliate_id: assuserId }),
          affiliate_profile: parseInt(eventData.affiliateId, 10),
          notes: eventData.eventNotes,
        };
      }

      if (eventId) {
        data["id"] = eventId;
        data["po_number"] = eventData.poNumber;
        this.props.eventUpdateAction(data);
      } else {
        this.props.eventAddAction(data);
      }
    } else {
      if (eventData.clientId == null) {
        formErrors.clientId = MSG_REQUIRED;
      }
      if (eventData.affiliateId == null) {
        formErrors.affiliateId = MSG_REQUIRED;
      }
      if (eventData.clientContactId == null) {
        formErrors.clientContactId = MSG_REQUIRED;
      }
      if (eventData.eventTitle == null) {
        formErrors.eventTitle = MSG_REQUIRED;
      }
      if (eventData.city == null) {
        formErrors.city = MSG_REQUIRED;
      }
      if (eventData.state == null) {
        formErrors.state = MSG_REQUIRED;
      }
      if (eventData.country == null) {
        formErrors.country = MSG_REQUIRED;
      }
      if (eventData.postcode == null) {
        formErrors.postcode = MSG_REQUIRED;
      }
      if (eventData.startDate == null) {
        formErrors.startDate = MSG_REQUIRED;
      }
      if (eventData.endDate == null) {
        formErrors.endDate = MSG_REQUIRED;
      }
      if (eventData.startTime == null) {
        formErrors.startTime = MSG_REQUIRED;
      }
      if (eventData.endTime == null) {
        formErrors.endTime = MSG_REQUIRED;
      }
      initialValidation = true
      this.setState({ formErrors, initialValidation });
    }
  };

  onFilterClose = () => {
    // if(document.getElementById('detailTabTwo').style.display) {
    //     console.log('Show Event Details');
    // }
  };

  showShiftDetails = (shiftId) => {
    this.setState({ activeShiftId: shiftId });
    document.getElementById("filterByMenu").classList.add("active");

    let filterByMenu = document.getElementById("filterByMenu");
    filterByMenu.style.width = "1000px";
    filterByMenu.style.right = "0";

    let filterTab = document.getElementById("filterTab");
    let quoteTab = document.getElementById("detailTab");
    let shiftDetTab = document.getElementById("detailTabTwo");
    filterTab.style.display = "none";
    quoteTab.style.display = "none";
    shiftDetTab.style.display = "block";
  };

  showActiveEventDetails = () => {
    let quoteTab = document.getElementById("detailTab");
    let filterTab = document.getElementById("filterTab");
    let shiftDetTab = document.getElementById("detailTabTwo");
    quoteTab.style.display = "block";
    filterTab.style.display = "none";
    shiftDetTab.style.display = "none";
  };

  showQuoteDetails = (id) => {
    let { activeTab } = this.state;
    this.setState({ eventIdSelected: id });
    if (this.state.isFilterOn) {
      this.inputFilter.click();
    }
    document.getElementById("filterByMenu").classList.toggle("active");
    let filterByMenu = document.getElementById("filterByMenu");
    let quoteTab = document.getElementById("detailTab");
    let filterTab = document.getElementById("filterTab");
    let shiftDetTab = document.getElementById("detailTabTwo");
    quoteTab.style.display = "block";
    filterTab.style.display = "none";
    shiftDetTab.style.display = "none";
    filterByMenu.style.width = "1000px";
    filterByMenu.style.right = "0";

    if (activeTab === TAB1) {
      this.props.eventQuoteSummaryAction(id);
      this.props.eventSummaryAction(id);
    } else if (activeTab === TAB2) {
      this.props.eventSummaryAction(id);
      this.props.eventQuoteSummaryAction(id);
    } else if (activeTab === TAB3) {
      this.props.eventClientDetailsAction(id);
      this.props.eventQuoteSummaryAction(id);
    } else if (activeTab === TAB4) {
      this.props.eventQuoteSummaryAction(id);
      this.props.eventUserLogsListAction({
        pageSize: PAGENUMROWS_AFFILIATE,
        eventId: id,
      });
    } else if (activeTab === TAB5) {
      this.props.listEventShiftsAction(id);
      this.props.eventQuoteSummaryAction(id);
    } else if (activeTab === TAB6) {
      this.props.listEventMessagesAction(id);
      this.props.eventQuoteSummaryAction(id);
    } else if (activeTab === TAB7) {
      this.props.listInvoiceAction(id);
      this.props.eventQuoteSummaryAction(id);
    }
  };



  reloadQuoteDetails = () => {
    if (
      document.getElementById("detailTab").style.display &&
      this.state.eventIdSelected &&
      this.state.eventIdSelected.length > 0
    ) {
      this.props.eventQuoteSummaryAction(this.state.eventIdSelected);
    }
  };

  onShowFilterBy = () => {
    let filterClicked = this.state.filterClicked + 1;
    // this.setState(prevState => ({ isFilterOn: !prevState.isFilterOn, filterClicked:filterClicked }));
    document.getElementById("filterByMenu").classList.toggle("active");
    document.getElementById("filterIcon").classList.toggle("active");
    let filterByMenu = document.getElementById("filterByMenu");
    let quoteTab = document.getElementById("detailTab");
    let filterTab = document.getElementById("filterTab");
    let shiftDetTab = document.getElementById("detailTabTwo");
    filterTab.style.display = "block";
    quoteTab.style.display = "none";
    shiftDetTab.style.display = "none";
    if (this.state.isFilterOn) {
      filterByMenu.style.width = "580px";
      filterByMenu.style.right = "-580px";
    } else {
      filterByMenu.style.width = "580px";
      filterByMenu.style.right = "0";
    }
    this.setState((prevState) => ({
      isFilterOn: !prevState.isFilterOn,
      filterClicked: filterClicked,
    }));
  };

  closeDetailSlider = () => {
    document.getElementById("filterByMenu").classList.remove("active"); //to close the slider
    let filterByMenu = document.getElementById("filterByMenu");
    let filterTab = document.getElementById("filterTab");
    let quoteTab = document.getElementById("detailTab");
    let shiftDetTab = document.getElementById("detailTabTwo");
    filterTab.style.display = "block";
    quoteTab.style.display = "none";
    shiftDetTab.style.display = "none";
    filterByMenu.style.width = "450px";
    filterByMenu.style.right = "-1000px";
    this.setState({ activeTab: TAB1, loadPreviewQuoteEventId: 0 });
  };

  onSearchLocation = (query) => {
    let { eventData } = this.state;
    if (query.length >= SEARCH_TEXT_COUNT) {
      this.props.quoteEventLocationListAction({
        pageSize: "",
        page: 0,
        column: "-id",
        search: query,
        affiliateId: eventData.affiliateId,
      });
    }
  };

  onSelectLocation = (selected) => {
    let { eventData, formErrors } = this.state;
    if (selected.length > 0) {
      let selectedLoc = selected[0];
      eventData["locationId"] = selectedLoc.id;
      eventData["location"] =
        selectedLoc.location === null ? "" : selectedLoc.location;
      eventData["googleLocation"] =
        selectedLoc.lat_long === null ? "" : selectedLoc.lat_long;
      eventData["venue"] = selectedLoc.venue === null ? "" : selectedLoc.venue;
      eventData["streetOne"] =
        selectedLoc.street1 === null ? "" : selectedLoc.street1;
      eventData["streetTwo"] =
        selectedLoc.street2 === null ? "" : selectedLoc.street2;
      eventData["city"] = selectedLoc.city === null ? "" : selectedLoc.city;
      eventData["state"] = selectedLoc.state === null ? "" : selectedLoc.state;
      eventData["country"] =
        selectedLoc.country === null ? "" : selectedLoc.country;
      eventData["postcode"] =
        selectedLoc.postcode === null ? "" : selectedLoc.postcode;
      formErrors["locationId"] = "";
      formErrors["city"] = "";
      formErrors["state"] = "";
      formErrors["country"] = "";
      formErrors["postcode"] = "";
      this.setState({ eventData, formErrors });
    }
  };

  onStartDateChange = (date) => {
    let { formErrors, eventData } = this.state;
    let startDate = format(new Date(date), "yyyy-MM-dd");
    formErrors.startDate = "";
    eventData["startDate"] = startDate;
    eventData["endDate"] = startDate;
    this.setState({ eventData, formErrors });
  };

  onEndDateChange = (date) => {
    let { formErrors, eventData } = this.state;
    let endDate = format(new Date(date), "yyyy-MM-dd");
    formErrors.endDate = "";
    eventData["endDate"] = endDate;
    formErrors.endTime = "";
    this.setState({ eventData, formErrors });
  };

  onStartTimeChange = (time) => {
    let { formErrors, eventData } = this.state;
    if (time._d !== undefined) {
      let startTime = format(new Date(time._d), "HH:mm");
      eventData["startTime"] = startTime;
      formErrors.endTime = "";
      this.setState({ eventData, formErrors });
    }
  };

  onStartTimeBlur = (time) => {
    let { formErrors, eventData } = this.state;
    if (time._d !== undefined) {
      let startTime = format(new Date(time._d), "HH:mm");
      eventData["startTime"] = startTime;
      formErrors.startTime = "";
      this.setState({ eventData, formErrors });
    } else {
      try {
        var d = new Date(),
          s = time,
          parts = s.match(/(\d+)\:(\d+)/),
          hours = parseInt(parts[1].trim(), 10),
          minutes = parseInt(parts[2].trim(), 10);

        d.setHours(hours);
        d.setMinutes(minutes);
        let startime = format(d, "HH:mm");
        eventData["startTime"] = startime;
        formErrors.startTime = "";
      } catch (err) {
        formErrors.startTime = MSG_REQUIRED;
      }
    }
    this.setState({ eventData, formErrors });
  };

  onEndTimeChange = (time) => {
    let { formErrors, eventData } = this.state;
    if (time._d !== undefined) {
      let endTime = format(new Date(time._d), "HH:mm");
      eventData["endTime"] = endTime;
      this.setState({ eventData, formErrors });
    }
  };

  onEndTimeBlur = (time) => {
    let { formErrors, eventData } = this.state;
    if (time._d !== undefined) {
      let endTime = format(new Date(time._d), "HH:mm");
      eventData["endTime"] = endTime;
      formErrors.endTime = "";
      this.setState({ eventData, formErrors });
    } else {
      try {
        var d = new Date(),
          s = time,
          parts = s.match(/(\d+)\:(\d+)/),
          hours = parseInt(parts[1].trim(), 10),
          minutes = parseInt(parts[2].trim(), 10);

        d.setHours(hours);
        d.setMinutes(minutes);
        let endTime = format(d, "HH:mm");
        eventData["endTime"] = endTime;
        formErrors.endTime = "";
      } catch (err) {
        formErrors.endTime = MSG_REQUIRED;
      }
    }
    this.setState({ eventData, formErrors });
  };

  startAndEndTimeDifference = () => {
    let { eventData, formErrors } = this.state;
    let startTime = eventData.startTime.split(":");
    let startMinutes = +startTime[0] * 60 + +startTime[1];
    let startDate = format(new Date(eventData.startDate), "yyyy-MM-dd");

    let endTime = eventData.endTime.split(":");
    let endMinutes = +endTime[0] * 60 + +endTime[1];
    let endDate = format(new Date(eventData.endDate), "yyyy-MM-dd");
    if (
      (startMinutes !== 0 || endMinutes !== 0) &&
      startMinutes >= endMinutes &&
      startDate === endDate
    ) {
      formErrors.endTime = MSG_REQUIRED;
      return false;
    } else {
      formErrors.endTime = "";
      return true;
    }
    // this.setState({formErrors});
  };

  quoteOrInvoice = (e, eventId, showSendInvoice) => {
    let eventSelOption = this.state.eventSelOption;
    let selObj = {
      eventId: eventId,
      fileType: e.target.value,
      showSendInvoice: showSendInvoice,
    };
    if (!eventSelOption.length) {
      eventSelOption.push(selObj);
      this.setState({ eventSelOption, fileType: e.target.value });
    } else {
      let newSelObject = [];
      let foundObj = 0;
      eventSelOption.forEach((item) => {
        if (Number(item.eventId) === Number(eventId)) {
          foundObj = 1;
          newSelObject.push(selObj);
        } else {
          newSelObject.push(item);
        }
      });
      if (foundObj === 0) {
        newSelObject.push(selObj);
      }
      this.setState({ eventSelOption: newSelObject, fileType: e.target.value });
    }
  };

  quoteOrInvoiceDownload = (e, eventId, fileType) => {
    if (!this.state.isEvent || this.state.isEvent === 0) {
      this.props.quoteDownloadAction(eventId);
    }
    if (fileType === "0") {
      this.props.quoteDownloadAction(eventId);
    } else if (fileType === "1") {
      this.props.invoiceDownloadAction(eventId);
    }
  };

  openEventDeleteModal = (eventId, eventTitle) => {
    this.setState({
      eventId: eventId,
      eventDeleteTitle: eventTitle,
    });
    this.modalQuoteDelete.current.handleOpenModal();
  };

  onEventLayoutToggle = (e, value) => {
    this.setState({ isListLayout: value });
    this.onApplyFilterButton();
  };

  onTabChangeSet = (tab) => {
    this.setState({ activeTab: tab });
  };

  reloadEventList = () => {
    this.props.eventListAction({
      isEvent: this.state.isEvent,
      pageSize: this.state.perPageCount,
      page: this.state.activePage,
      column: this.state.sortOrder + this.state.sortField,
      search: this.state.searchQuote,
      applyFilter: this.state.applyFilter,
      filtersData: this.state.filtersData,
    });
  };

  setStateUpdate(
    numRows,
    totalPage,
    activityStr,
    errorData,
    status,
    eventData,
    eventId
  ) {
    let formErrors = this.state.formErrors;
    let { hrefEventId } = this.state;

    let arrResp = activityStr ? activityStr.split("~~") : [];
    let activity = arrResp[0] ? arrResp[0] : "";
    if (activity === types.EVENT_ADD_SUCCESS) {
      this.modalQuote.current.handleModelClose();
      //this.props.clientContactListAction({clientId:eventData.clientId,column:'-id'});

      this.setState(
        {
          eventDataForShift: {
            eventId: eventData.eventId,
            eventTitle: eventData.eventTitle,
            clientId: eventData.clientId,
            affiliateId: eventData.affiliateId,
            location: eventData.location === null ? "" : eventData.location,
            venueName:
              eventData.venueName === null || eventData.venueName === undefined
                ? ""
                : eventData.venueName,
            streetOne: eventData.streetOne === null ? "" : eventData.streetOne,
            streetTwo: eventData.streetTwo === null ? "" : eventData.streetTwo,
            city: eventData.city === null ? "" : eventData.city,
            state: eventData.state === null ? "" : eventData.state,
            country: eventData.country === null ? "" : eventData.country,
            postcode: eventData.postcode === null ? "" : eventData.postcode,
            startDate: eventData.startDate,
            endDate: eventData.endDate,
            googleLocation: eventData.googleLocation
          },
        },
        () => this.shiftRef.current.openShiftModal()
      );
      this.reloadEventList();
    } else if (activity === types.EVENT_ADD_ERROR) {
      if (status === 400) {
        if (errorData.hasOwnProperty("client_contact")) {
          formErrors.clientContactId = errorData.client_contact[0];
        }
        if (errorData.hasOwnProperty("title")) {
          formErrors.eventTitle = errorData.title[0];
        }
        if (errorData.hasOwnProperty("start_date")) {
          formErrors.startDate = errorData.start_date[0];
        }
        if (errorData.hasOwnProperty("end_date")) {
          formErrors.endDate = errorData.end_date[0];
        }
        if (errorData.hasOwnProperty("location")) {
          // formErrors.streetOne = errorData.location[0];
          // formErrors.streetTwo = errorData.location[0];
          // formErrors.city = errorData.location[0];
          // formErrors.state = errorData.location[0];
          // formErrors.country = errorData.location[0];
          // formErrors.postcode = errorData.location[0];
        }
        // else{
        //    this.setToasterState(true,JSON.stringify(errorData),false);
        // }
        this.setState(formErrors);
      } else {
        this.modalQuote.current.handleModelClose();
        this.setToasterState(true, MSG_EVENT_ADD_ERROR, false);
        // if(errorData.hasOwnProperty('message')){
        //    this.setToasterState(true,errorData.message,false);
        // }else{
        //    this.setToasterState(true,JSON.stringify(errorData),false);
        // }
      }
    } else if (activity === types.EVENT_EDIT_SUCCESS) {
      // CONVERT DATE AND TIME TO TIMEZONE OF USER'S SETTING
      let timeZone = getUserTimeZone(this.props.location);
      let sDate = converDateToLocal(
        eventData.startDate,
        "+00:00",
        "yyyymmddThhmmss",
        "-"
      );
      let eDate = converDateToLocal(
        eventData.endDate,
        "+00:00",
        "yyyymmddThhmmss",
        "-"
      );
      let arrTime = [];
      arrTime = sDate.split("T");
      let sTime = arrTime[1].substring(0, 5);
      arrTime = eDate.split("T");
      let eTime = arrTime[1].substring(0, 5);

      this.setState({
        eventData: {
          affiliateId: eventData.affiliateId,
          clientId: eventData.clientId,
          clientContactId: eventData.clientContactId,
          eventTitle: eventData.eventTitle,
          quoteNumber: eventData.quoteNumber,
          locationId: eventData.location,
          location: "",
          googleLocation: eventData.googleLocation,
          venue:
            eventData.venue === null || eventData.venue === undefined
              ? ""
              : eventData.venue,
          streetOne: eventData.streetOne ? eventData.streetOne : "",
          streetTwo: eventData.streetTwo ? eventData.streetTwo : "",
          city: eventData.city ? eventData.city : "",
          state: eventData.state ? eventData.state : "",
          country: eventData.country ? eventData.country : "",
          postcode: eventData.postcode ? eventData.postcode : "",
          // startDate:new Date(eventData.startDate),
          // endDate:new Date(eventData.endDate),
          // endTime:format(new Date(eventData.endDate),'HH:mm'),
          // startTime:format(new Date(eventData.startDate),'HH:mm'),
          startDate: sDate,
          endDate: eDate,
          startTime: sTime,
          endTime: eTime,
          poNumber: eventData.poNumber,
          noLocationFound: false,
          eventNotes: eventData.eventNotes ? eventData.eventNotes : "",
          status: eventData.status,
          created_by: eventData.hasOwnProperty("created_by")
            ? eventData.created_by
            : "",
        },
        eventId: eventData.eventId,
        formErrors: {
          clientId: "",
          clientContactId: "",
          eventTitle: "",
          locationId: "",
          city: "",
          state: "",
          country: "",
          postcode: "",
          startDate: "",
          endDate: "",
          startTime: "",
          endTime: "",
        },
      });
    } else if (activity === types.EVENT_UPDATE_SUCCESS) {

      this.modalQuote.current.handleModelClose();
      this.reloadEventList();
      this.reloadQuoteDetails();
      this.setToasterState(true, MSG_QUOTE_UPDATE, true);
      if (this.state.eventIdSelected) {
        this.props.eventQuoteSummaryAction(this.state.eventIdSelected);
      }


      this.setState(
        {
          eventDataForShift: {
            eventId: eventData.eventId,
            eventTitle: eventData.eventTitle,
            clientId: eventData.clientId,
            affiliateId: eventData.affiliateId,
            location: eventData.location === null ? "" : eventData.location,
            venueName:
              eventData.venueName === null || eventData.venueName === undefined
                ? ""
                : eventData.venueName,
            streetOne: eventData.streetOne === null ? "" : eventData.streetOne,
            streetTwo: eventData.streetTwo === null ? "" : eventData.streetTwo,
            city: eventData.city === null ? "" : eventData.city,
            state: eventData.state === null ? "" : eventData.state,
            country: eventData.country === null ? "" : eventData.country,
            postcode: eventData.postcode === null ? "" : eventData.postcode,
            startDate: eventData.startDate,
            endDate: eventData.endDate,
            googleLocation: eventData.googleLocation
          },
        },
        () => this.shiftRef.current.openShiftModal()
      );



    } else if (activity === types.EVENT_UPDATE_ERROR) {
      if (status === 400) {
        if (errorData.hasOwnProperty("client_contact")) {
          formErrors.clientContactId = errorData.client_contact[0];
        }
        if (errorData.hasOwnProperty("title")) {
          formErrors.eventTitle = errorData.title[0];
        }
        if (errorData.hasOwnProperty("start_date")) {
          formErrors.startDate = errorData.start_date[0];
        }
        if (errorData.hasOwnProperty("end_date")) {
          formErrors.endDate = errorData.end_date[0];
        }
        if (errorData.hasOwnProperty("location")) {
          // formErrors.streetOne = errorData.location[0];
          // formErrors.streetTwo = errorData.location[0];
          // formErrors.city = errorData.location[0];
          // formErrors.state = errorData.location[0];
          // formErrors.country = errorData.location[0];
          // formErrors.postcode = errorData.location[0];
        }
        this.setState(formErrors);
      } else {
        this.modalQuote.current.handleModelClose();
        this.setToasterState(true, MSG_DATA_SAVE_ERROR, false);
        // if(errorData.hasOwnProperty('message')){
        //    this.setToasterState(true,errorData.message,false);
        // }else{
        //    this.setToasterState(true,errorData.hasOwnProperty('message') ? errorData.message : JSON.stringify(errorData),false);
        // }
      }
    } else if (activity === types.EVENT_DELETE_SUCCESS) {
      if (numRows === 1 && totalPage > 1) {
        let page = this.state.activePage - 1;
        this.props.eventListAction({
          isEvent: this.state.isEvent,
          pageSize: this.state.perPageCount,
          page: page,
          column: this.state.sortOrder + this.state.sortField,
          search: this.state.searchQuote,
          applyFilter: this.state.applyFilter,
          filtersData: this.state.filtersData,
        });
      } else {
        this.reloadEventList();
      }
      this.setToasterState(true, MSG_QUOTE_DELETE, true);
      this.closeDetailSlider();
    } else if (activity === types.EVENT_DELETE_ERROR) {
      this.setToasterState(true, MSG_DATA_SAVE_ERROR, false);
      //this.setToasterState(true,errorData.hasOwnProperty('message') ? errorData.message : JSON.stringify(errorData),false);
    } else if (activity === types.EVENT_LIST_SUCCESS) {
      if (hrefEventId !== undefined && this.state.hrefEventIdUsed === 0) {
        let activeTab = TAB1;
        if (
          this.props.location &&
          this.props.location.state &&
          this.props.location.state.quoteNumber
        ) {
          activeTab = TAB7;
        }
        this.setState({ hrefEventIdUsed: 1, activeTab: activeTab }, () => {
          this.showQuoteDetails(hrefEventId);
        });
      }
      // if (this.props.eventPopupId && Number(this.props.eventPopupId) > 0) {
      //   this.showQuoteDetails(this.props.eventPopupId);
      //   this.props.eventPopupIdResetAction("");
      // }
    } else if (activity === types.EVENT_CANCEL_SUCCESS) {
      this.setToasterState(true, MSG_QUOTE_CANCELLED, true);
      this.closeDetailSlider();
      this.reloadEventList();
      this.setState({ cancelReasonId: "" });
    } else if (activity === types.EVENT_CANCEL_ERROR) {
      this.setToasterState(true, MSG_DATA_SAVE_ERROR, false);
      // this.setToasterState(true,errorData.hasOwnProperty('message') ? errorData.message : JSON.stringify(errorData),false);
    } else if (activity === types.QUOTE_ACCEPT_SUCCESS) {
      if (this.props.clientSignature) {
        let userGroupData = userGroupUrlCheck(window.location);
        if (
          userGroupData !== undefined &&
          userGroupData.user_group &&
          userGroupData.user_group === LOGIN_CLIENT_GROUP
        ) {
          let signature = this.props.clientSignature;
          userGroupData.signature = signature;
          setStorage("client", JSON.stringify(userGroupData));
        }
      }
    }
  }

  componentDidUpdate(prevProps) {
    const {
      isFilterOn,
      numRows,
      totalPage,
      activity,
      errorData,
      status,
      eventData,
      eventId,
      eventPopupId,
      validateResponse,
      validateStatus,
      validateActivity,
      validateErrorData,
      popUpModal,
      dashboardActionRequired,
      downloadEvents,
      downloadStatus,
      downloadActivity,
      invoiceDownloadEvents,
      invoiceDownloadStatus,
      invoiceDownloadActivity,
    } = this.props;
    let arrDn = [];
    if (
      this.props.serverTimeListActivity &&
      this.props.serverTimeListActivity !== prevProps.serverTimeListActivity
    ) {
      let arrTimeResp = this.props.serverTimeListActivity.split("~~");
      if (arrTimeResp[0] === types.SERVER_TIME_LIST_SUCCESS) {
        let defaultStartDate = new Date(
          this.props.serverTimeList.current_date + "T00:00:00"
        );
        defaultStartDate = format(
          new Date(defaultStartDate.setDate(defaultStartDate.getDate() + 1)),
          "yyyy-MM-dd"
        );
        if (!eventId) {
          this.setState(
            { defaultStartDate: defaultStartDate, eventData: eventData },
            () => {
              this.onModalFormReset();
            }
          );
        } else {
          this.setState({ defaultStartDate: defaultStartDate });
        }
      }
    }
    if (
      downloadActivity &&
      (downloadStatus !== prevProps.downloadStatus ||
        downloadActivity !== prevProps.downloadActivity)
    ) {
      arrDn = downloadActivity.split("~~");
      if (arrDn[0] === types.EVENT_LIST_DOWNLOAD_SUCCESS) {
        this.setState(
          { exportQuote: this.formatQuoteArray(downloadEvents) },
          () => {
            setTimeout(() => {
              let csvDownload = document.getElementById("CSVLinkDownload");
              csvDownload.click();
            }, 500);
          }
        );
      } else if (arrDn[0] === types.EVENT_LIST_DOWNLOAD_ERROR) {
        this.setToasterState(true, MSG_CSV_DOWNLOAD_ERROR, false);
      }
    }
    let arrDnInv = [];
    if (
      invoiceDownloadActivity &&
      (invoiceDownloadStatus !== prevProps.invoiceDownloadStatus ||
        invoiceDownloadActivity !== prevProps.invoiceDownloadActivity)
    ) {
      arrDnInv = invoiceDownloadActivity.split("~~");
      if (arrDnInv[0] === types.INVOICE_LIST_DOWNLOAD_SUCCESS) {
        if (
          invoiceDownloadEvents &&
          Array.isArray(invoiceDownloadEvents) &&
          invoiceDownloadEvents.length
        ) {
          this.setState(
            {
              exportInvoiceData: this.formatInvoiceArray(invoiceDownloadEvents),
            },
            () => {
              setTimeout(() => {
                let csvDownload = document.getElementById(
                  "CSVLinkDownloadInvoice"
                );
                if (csvDownload) csvDownload.click();
              }, 500);
            }
          );
        } else {
          this.setToasterState(true, MSG_NOT_FOUND, false);
        }
      } else if (arrDnInv[0] === types.INVOICE_LIST_DOWNLOAD_ERROR) {
        this.setToasterState(true, MSG_CSV_DOWNLOAD_ERROR, false);
      }
    }

    let arrTemp = [];
    if (
      activity &&
      (status !== prevProps.status || activity !== prevProps.activity)
    ) {
      arrTemp = activity.split("~~");
      if (arrTemp[0] === types.EVENT_COMPLETE_SUCCESS) {
        this.setToasterState(true, MSG_EVENT_COMPLETE_SUCCESS, true);
        this.props.eventListAction({
          isEvent: this.state.isEvent,
          pageSize: this.state.perPageCount,
          page: this.state.activePage,
          column: this.state.sortOrder + this.state.sortField,
          search: this.state.searchQuote,
          applyFilter: this.state.applyFilter,
          filtersData: this.state.filtersData,
        });
        if (this.state.eventIdSelected > 0) {
          this.showQuoteDetails(this.state.eventIdSelected);
        }
      } else if (arrTemp[0] === types.EVENT_COMPLETE_ERROR) {
        this.setToasterState(true, MSG_EVENT_COMPLETE_ERROR, false);
      }
    }

    if (
      validateActivity &&
      (validateStatus !== prevProps.validateStatus ||
        validateActivity !== prevProps.validateActivity)
    ) {
      arrTemp = validateActivity.split("~~");
      if (arrTemp[0] === types.VALIDATE_EVENT_ADD_SUCCESS) {
        if (validateStatus !== 200) {
          if (
            validateResponse.mandatories &&
            Array.isArray(validateResponse.mandatories)
          ) {
            this.setState({ validationMsgArr: validateResponse.mandatories });
          } else {
            this.setState({ validationMsgArr: ["common_error"] });
          }
        }
      }
      // validateErrorData
    }

    if ((eventPopupId && Number(eventPopupId) > 0) && ((eventPopupId !== prevProps.eventPopupId) || eventPopupId !== this.state.eventIdSelected)) {
      const eid = eventPopupId;
      this.props.eventPopupIdResetAction("");
      setTimeout(() => {
        this.showQuoteDetails(eid);
      }, 250);

    }
    if (isFilterOn !== prevProps.isFilterOn) {
      this.inputFilter.click();
    } else if (activity !== prevProps.activity) {
      this.setStateUpdate(
        numRows,
        totalPage,
        activity,
        errorData,
        status,
        eventData,
        eventId
      );
      this.props.clearAction();
    }
    if (popUpModal) {
      this.openModal();
      this.props.fromDashboard(false);
    }
  }

  componentDidMount() {
    this.props.serverTimeAction();
    const { location } = this.props;
    const { eventData } = this.state;
    let { signature } = this.state;
    let quoteNumber = "";
    let eventId = null;
    if (location.state && location.state.quoteNumber) {
      quoteNumber = location.state.quoteNumber;
      eventId = location.state.eventId;
      this.setState(
        { searchQuote: quoteNumber, hrefEventIdUsed: 0, hrefEventId: eventId },
        () => {
          // this.props.eventListAction({isEvent:this.state.isEvent,pageSize:this.state.perPageCount,page:1,column:this.state.sortOrder+this.state.sortField,search:this.state.searchQuote});
        }
      );
    }
    let userGroupData = userGroupUrlCheck(location);
    let userGroup = "";
    let profileId = "";
    let assuserId = "";
    let profileCurrency = "";
    if (userGroupData !== undefined) {
      userGroup = userGroupData.user_group;
      profileId = userGroupData.profile_id;
      assuserId = userGroupData.associate_id;
      profileCurrency = userGroupData.profile_currency;
      signature = userGroupData.signature;
    }
    if (signature) {
      this.setState({ signature });
    }
    if (userGroup === LOGIN_AFFILIATE_GROUP) {
      document.body.classList.add("body-affiliate");
      this.setState({ isClientPage: false });
      eventData["affiliateId"] = Number(profileId);
    } else if (userGroup === LOGIN_CLIENT_GROUP) {
      eventData["affiliateId"] = Number(
        userGroupData.client_default_affiliate_id
      );
      eventData["clientId"] = Number(profileId);
      this.setState({ eventData });
      document.body.classList.add("body-client");
      this.setState({ isClientPage: true });
    } else {
      document.body.classList.add("body-super");
      this.setState({ isSuperAdminPage: true });
    }

    document.title = this.state.isEvent
      ? LBL_APP_NAME + " - " + LBL_EVENTS
      : LBL_APP_NAME + " - " + LBL_QUOTES;

    if (this.props.dashboardActionRequired) {
      this.onResetFiltersButton();
    } else {
      this.setState({
        userGroup: userGroup,
        profileId: profileId,
        assuserId: assuserId,
        profileCurrency: profileCurrency,
      });
      // this.props.eventListAction({isEvent:this.state.isEvent,pageSize:this.state.perPageCount,page:this.state.activePage,column:this.state.sortOrder+this.state.sortField,search:this.state.searchQuote});
    }
    this.props.aflt_departmentsListAction({ associated: "1" });
    this.props.cancelReasonsListAction();
    this.props.serverTimeAction();
  }

  formatQuoteArray(array) {
    let exportQuote = [];
    if (array.length > 0) {
      array.map((item) => {
        let crewObj = {};
        crewObj["created_date"] = format(
          new Date(item.created_on),
          "dd/MM/yyyy"
        );
        crewObj["quote_number"] =
          item.quote_number === null ? MSG_NOT_GENERATED : item.quote_number;
        crewObj["quote_title"] = item.title;
        crewObj["venue"] =
          item.location_detail.location.venue === null ||
            item.location_detail.location.venue === undefined
            ? ""
            : item.location_detail.location.venue;
        crewObj["street1"] = item.location_detail.location.street1
          ? item.location_detail.location.street1
          : "";
        crewObj["street2"] = item.location_detail.location.street2
          ? item.location_detail.location.street2
          : "";
        crewObj["city"] = item.location_detail.location.city
          ? item.location_detail.location.city
          : "";
        crewObj["state"] = item.location_detail.location.state
          ? item.location_detail.location.state
          : "";
        crewObj["country"] = item.location_detail.location.country
          ? item.location_detail.location.country
          : "";
        crewObj["postcode"] = item.location_detail.location.postcode
          ? item.location_detail.location.postcode
          : "";
        crewObj["client"] = item.client_profile_details.company_name;
        const filteredStatus = this.state.eventStatus.filter(
          (x) => Number(x.statusCode) === Number(item.status)
        );
        crewObj["event_status"] = filteredStatus[0].statusString;
        crewObj["team_count_assigned"] = item.team_count_assigned;
        crewObj["team_count_total"] = item.team_count_total;
        crewObj["shift_count"] = item.shifts_count;
        crewObj["po_number"] =
          item.po_number === null || item.po_number === ""
            ? MSG_NOT_GENERATED
            : item.po_number;
        exportQuote.push(crewObj);
        return exportQuote;
      });
    }
    return exportQuote;
  }

  formatInvoiceArray(array) {
    let exportQuote = [];
    if (array.length > 0) {
      array.map((item) => {
        let crewObj = {};
        crewObj["Invoice_Date"] = format(
          new Date(item.created_on),
          "dd/MM/yyyy"
        );
        crewObj["Invoice_Number"] =
          item.invoice_number === null
            ? MSG_NOT_GENERATED
            : item.invoice_number;
        crewObj["Client_Name"] = item.client_name;
        crewObj["Description"] = item.event_name;
        crewObj["Net_Amount"] = item.net_amount;
        crewObj["Vat_Amount"] = item.vat_amount;
        crewObj["Total_Amount"] = item.total_amount;
        crewObj["Invoice_Number"] = item.invoice_number;
        crewObj["Currency"] = item.currency_symbol;
        crewObj["Purchase_Reference"] = item.po_number;
        crewObj["Term_In_Days"] = item.term_in_days;
        exportQuote.push(crewObj);
        return exportQuote;
      });
    }
    return exportQuote;
  }

  onHandleReasonChange = (e) => {
    let value = e.target.value;
    this.setState({ cancelReasonId: value });
  };

  loadEventSchedule = (eventId, shiftDetails) => {
    if (shiftDetails) {
      // SKILLS NEED TO BE CONVERTED INTO OTHER FORMAT
      // "shift_skills":[{"id":4286,"skill_id":1306,"skill_name":"General","required":2,"requested":0,"assigned":0,"rejected":0,"pending":2}]
      // "shift_skills":[{"id":4225,"skill":{"id":1306,"skill_name":"General","is_active":true,"index":1,"affiliate":210},"scheduled":false,"pending":12,"chiefs_pending":3,"count":12,"requested":1,"assigned":0,"rejected":0,"chiefs_required":3,"chiefs_requested":0,"chiefs_accepted":0,"chiefs_rejected":0},
      let allSkills = [];
      shiftDetails.shift_skills.forEach((item) => {
        allSkills.push({
          id: item.id,
          skill: { id: item.skill_id, skill_name: item.skill_name },
          pending: item.pending,
          requested: item.requested,
          assigned: item.assigned,
          rejected: item.rejected,
          chiefs_pending: item.chiefs_pending ? item.chiefs_pending : 0,
          chiefs_required: item.chiefs_required ? item.chiefs_required : 0,
          chiefs_requested: item.chiefs_requested ? item.chiefs_requested : 0,
          chiefs_accepted: item.chiefs_accepted ? item.chiefs_accepted : 0,
          chiefs_rejected: item.chiefs_rejected ? item.chiefs_rejected : 0,
        });
      });

      let shiftDet = {
        start_datetime: shiftDetails.start_datetime,
        end_datetime: shiftDetails.start_datetime,
        shift_skills: allSkills,
        id: shiftDetails.shift_id,
        chiefs_required: shiftDetails.chiefs_required,
        chiefs_pending: shiftDetails.chiefs_pending,
        status: shiftDetails.status,
        department:
          shiftDetails.department_name !== null
            ? shiftDetails.department_name
            : "",
        resources: 1,
        pending: 1,
      };

      // this.gotoSchedule('',eventId,shiftDet);

      let shiftItems = [];
      if (shiftDet.pending > 0 && shiftDet.resources > 0) {
        shiftItems = [
          {
            start_datetime: shiftDet.start_datetime,
            end_datetime: shiftDet.start_datetime,
            skills: shiftDet.shift_skills,
            shiftId: shiftDet.id,
            chiefsRequired: shiftDet.chiefs_required,
            chiefsPending: shiftDet.chiefs_pending,
            isAllChecked: false,
            status: shiftDet.status,
            department: shiftDet.department !== null ? shiftDet.department : "",
          },
        ];
      }
      this.props.sendShiftIdsForScheduleAction(shiftItems);
      this.props.history.push(ROUTE_AFFILIATE_SCHEDULE_SHIFT + "/" + eventId);
    } else {
      this.props.history.push(ROUTE_AFFILIATE_SCHEDULE_SHIFT + "/" + eventId);
    }
  };

  render() {
    let {
      activePage,
      startIndex,
      endIndex,
      toastMessage,
      toastFlag,
      toastSuccess,
      eventStatus,
      isClientPage,
      eventActionTitle,
      isListLayout,
      quoteStatus,
      isSuperAdminPage,
      eventSelOption,
      isSignatureValid,
      signatureLabel,
      signature,
      signatureUrl,
      sortField,
      sortOrder,
    } = this.state;

    const {
      events,
      totalPage,
      status,
      clients,
      clientContacts,
      locations,
      affiliateList,
    } = this.props;
    let is_active = true;
    let userGroupData = userGroupUrlCheck(this.props.location);
    let userGroup = "";
    if (userGroupData !== undefined) {
      userGroup = userGroupData.user_group;
      is_active = userGroupData.is_active;
      if (signatureUrl === "") {
        signatureUrl = userGroupData.signature;
      }
    }

    if (status === 401 || status === 403) {
      if (userGroup === LOGIN_AFFILIATE_GROUP) {
        return <Redirect to={ROUTE_AFFILIATE_REFRESH} />;
      } else if (userGroup === LOGIN_CLIENT_GROUP) {
        return <Redirect to={ROUTE_CLIENT_REFRESH} />;
      } else {
        return <Redirect to={ROUTE_REFRESH} />;
      }
    }

    let headers = [
      { label: "Created Date", key: "created_date" },
      { label: "Quote No", key: "quote_number" },
      { label: LBL_EVENT + " Title", key: "quote_title" },
      { label: "Venue", key: "venue" },
      { label: "Street1", key: "street1" },
      { label: "Street2", key: "street2" },
      { label: "City", key: "city" },
      { label: "State", key: "state" },
      { label: "Country", key: "country" },
      { label: "Postcode", key: "postcode" },
      { label: "Client", key: "client" },
      { label: LBL_EVENT + " Status", key: "event_status" },
      { label: "Team Count Assigned", key: "team_count_assigned" },
      { label: "Team Count Total", key: "team_count_total" },
      { label: "Shift Count", key: "shift_count" },
      { label: "PO Number", key: "po_number" },
    ];

    let invoiceHeaders = [
      { label: "Invoice_Date", key: "Invoice_Date" },
      { label: "Invoice_Number", key: "Invoice_Number" },
      { label: "Client_Name", key: "Client_Name" },
      { label: "Description", key: "Description" },
      { label: "Net_Amount", key: "Net_Amount" },
      { label: "Vat_Amount", key: "Vat_Amount" },
      { label: "Total_Amount", key: "Total_Amount" },
      { label: "Invoice_Number", key: "Invoice_Number" },
      { label: "Currency", key: "Currency" },
      { label: "Purchase_Reference", key: "Purchase_Reference" },
      { label: "Term_In_Days", key: "Term_In_Days" },
    ];

    // let exportQuote = [];
    // exportQuote = this.formatQuoteArray(events);

    let timeZone = getUserTimeZone(this.props.location);
    // let isAddEvent = checkPermissions("events","modify");
    let isAddQuote = false;
    let isQuoteSummary = false;
    if (this.state.isEvent) {
      isAddQuote = is_active === true && checkPermissions("events", "modify");
    } else {
      isAddQuote = is_active === true && checkPermissions("quotes", "modify");
    }
    isQuoteSummary =
      is_active === true &&
      checkPermissions("quotessummary", "view") &&
      checkPermissions("quotes", "view");

    let isViewSchedule = checkPermissions("schedule", "view");

    let isAffiliateCanAcceptQuote = checkPermissions("acceptquote", "view"); // IF PERMISSION COMES SET THIS VARIABLE ACCORDING TO IT
    let canAcceptQuote = isClientPage ? true : isAffiliateCanAcceptQuote;
    let signatureLogoUrl = "";
    if (!signatureUrl) {
      signatureLogoUrl = signatureLogoUrl = require("../../" +
        URL_IMG +
        "signature.png");
    } else {
      signatureLogoUrl = signatureUrl;
    }
    let isClient = false;
    if (userGroup == LOGIN_CLIENT_GROUP) {
      isClient = true;
    }

    return (
      <React.Fragment>
        <div className="col-md-12">
          <Toast
            toastDescription={toastMessage}
            toastFlag={toastFlag}
            toastSuccess={toastSuccess}
            closeToast={this.onCloseToast}
          />

          <div className="box">
            <div className="box-head ">
              <div className={isListLayout ? "dataTables_filter" : "hide"}>
                <label>
                  <input
                    type="search"
                    className=""
                    placeholder={LBL_EVENT_TITLE + "/" + LBL_QUOTE_NO}
                    id="my-search-input"
                    onChange={this.onSearchQuote}
                    value={this.state.searchQuote}
                  />
                </label>
              </div>

              <div
                className={
                  this.state.applyFilter
                    ? "filter-btn-wrapper  text-primary-filter"
                    : "filter-btn-wrapper text-primary"
                }
              >
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 450, hide: 250 }}
                  overlay={
                    <Tooltip
                      id="filterIcon-tooltip"
                      style={{
                        opacity: 0.4,
                      }}
                    >
                      {LBL_FILTER}
                    </Tooltip>
                  }
                >
                  <button
                    id="filterIcon"
                    ref={(input) => (this.inputFilter = input)}
                    onClick={this.onShowFilterBy}
                    className={
                      this.state.applyFilter
                        ? "filter-btn  text-primary-filter"
                        : "filter-btn text-primary"
                    }
                  >
                    <i className="las la-filter"></i>
                  </button>
                </OverlayTrigger>
              </div>

              {this.state.applyFilter > 0 && (
                <div className="text-12 div150">
                  &nbsp; &nbsp;{" "}
                  <Link to="#" onClick={this.onResetFiltersButton}>
                    {LBL_CLEAR_FILTERS}
                  </Link>
                </div>
              )}

              {userGroup !== LOGIN_SUPER_ADMIN_GROUP && (
                <div className="to-right padding-right-15">
                  {this.state.isEvent === 0 && isAddQuote && (
                    <Link
                      to="#"
                      className="btn btn-primary"
                      onClick={this.openModal}
                    >
                      {LBL_PLUS_NEW_QUOTE}
                    </Link>
                  )}
                </div>
              )}

              <div
                className={
                  this.state.isEvent
                    ? "btn-group btn-group-sm to-right toggle-view padding-right-15"
                    : "btn-group btn-group-sm to-right toggle-view "
                }
              >
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 450, hide: 250 }}
                  overlay={
                    <Tooltip id="list-tooltip" style={{ opacity: 0.4 }}>
                      {LBL_LIST_VIEW}
                    </Tooltip>
                  }
                >
                  <Link
                    className={
                      isListLayout
                        ? "btn btn-outline-primary active"
                        : "btn btn-outline-primary"
                    }
                    to="#"
                    onClick={(e) => this.onEventLayoutToggle(e, true)}
                  >
                    <i className="las la-bars"></i>{" "}
                  </Link>
                </OverlayTrigger>
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 450, hide: 250 }}
                  overlay={
                    <Tooltip id="calendar-tooltip" style={{ opacity: 0.4 }}>
                      {LBL_CALENDAR_VIEW}
                    </Tooltip>
                  }
                >
                  <Link
                    className={
                      !isListLayout
                        ? "btn btn-outline-primary active"
                        : "btn btn-outline-primary"
                    }
                    to="#"
                    onClick={(e) => this.onEventLayoutToggle(e, false)}
                  >
                    <i className="las la-calendar"></i>{" "}
                  </Link>
                </OverlayTrigger>
              </div>

              {this.state.isEvent === 1 && !isClientPage && isAddQuote && (
                <div className="btn-group btn-group-sm to-right export-icon filter-btn-wrapper">
                  {this.props.hasOwnProperty("count") &&
                    this.props.count > 0 && (
                      <OverlayTrigger
                        placement="top"
                        delay={{ show: 250, hide: 400 }}
                        overlay={
                          <Tooltip
                            id="download-tooltip"
                            style={{ opacity: 0.4 }}
                          >
                            {LBL_INVICE_EXPORT}
                          </Tooltip>
                        }
                      >
                        <Link
                          to="#"
                          onClick={(e) => this.onInvoiceCSVDownload()}
                          className="btn btn-outline-primary filter-btn"
                        >
                          <i className="las la-file-invoice-dollar"></i>
                        </Link>
                      </OverlayTrigger>
                    )}
                </div>
              )}
              {isAddQuote && (
                <div className="btn-group btn-group-sm to-right export-icon filter-btn-wrapper">
                  {this.props.hasOwnProperty("count") &&
                    this.props.count > 0 && (
                      <OverlayTrigger
                        placement="top"
                        delay={{ show: 250, hide: 400 }}
                        overlay={
                          <Tooltip
                            id="download-tooltip"
                            style={{ opacity: 0.4 }}
                          >
                            {LBL_DOWNLOAD}
                          </Tooltip>
                        }
                      >
                        <Link
                          to="#"
                          onClick={(e) => this.onCSVDownload()}
                          className="btn btn-outline-primary filter-btn"
                        >
                          <i className="las la-file-download"></i>
                        </Link>
                      </OverlayTrigger>
                    )}
                </div>
              )}
              {/* <CSVLink className="btn btn-outline-primary filter-btn" data={this.state.exportQuote} headers={headers} filename= {"quote-list.csv"}><i className="las la-file-download"></i></CSVLink> */}
              {this.state.exportQuote.length > 0 && (
                <CSVLink
                  id="CSVLinkDownload"
                  className="hidden"
                  data={this.state.exportQuote}
                  headers={headers}
                  filename={
                    this.state.isEvent === 0
                      ? FILE_CSVDOWNLOAD_QUOTES
                      : FILE_CSVDOWNLOAD_EVENTS
                  }
                ></CSVLink>
              )}
              {this.state.isEvent === 1 &&
                isAddQuote &&
                this.state.exportInvoiceData.length > 0 && (
                  <CSVLink
                    id="CSVLinkDownloadInvoice"
                    className="hidden"
                    data={this.state.exportInvoiceData}
                    headers={invoiceHeaders}
                    filename={
                      this.state.isEvent === 0
                        ? "quote-list.csv"
                        : "invoice-list.csv"
                    }
                  ></CSVLink>
                )}
            </div>
            <div className="box-content">
              {isListLayout && (
                <>
                  <div className="table-responsive">
                    <table
                      id="data-table"
                      className="table"
                      style={{ width: "100%" }}
                    >
                      <thead>
                        <tr>
                          {/* <th className="sorting_disabled">
                                            <div className="custom-checkbox"><input type="checkbox" id="event-check1" /><label
                                                className="checkbox" htmlFor="event-check1"></label></div>
                                        </th> */}
                          <th>{LBL_SLNUM}</th>
                          {/* <th onClick={(e) => this.onSort(e,'created_on')} className="state sorting_asc">Date</th>     */}
                          <th
                            onClick={(e) => this.onSort(e, "title")}
                            className="last-login-date spanPointer"
                          >
                            {LBL_EVENT_TITLE}{" "}
                            <i
                              className={
                                sortField == "title"
                                  ? getSortClass(1, sortOrder)
                                  : getSortClass()
                              }
                            ></i>
                          </th>
                          {isSuperAdminPage && (
                            <th
                              onClick={(e) =>
                                this.onSort(
                                  e,
                                  "affiliate_profile__company_name"
                                )
                              }
                              className="last-login-date spanPointer"
                            >
                              {LBL_AFFILIATE}{" "}
                              <i
                                className={
                                  sortField == "affiliate_profile__company_name"
                                    ? getSortClass(1, sortOrder)
                                    : getSortClass()
                                }
                              ></i>
                            </th>
                          )}
                          <th className="text-center min-width-125">
                            {LBL_QUOTE_NO}
                          </th>
                          <th
                            onClick={(e) =>
                              this.onSort(e, "location__location")
                            }
                            className="location-name spanPointer"
                          >
                            {LBL_LOCATION}{" "}
                            <i
                              className={
                                sortField == "location__location"
                                  ? getSortClass(1, sortOrder)
                                  : getSortClass()
                              }
                            ></i>
                          </th>
                          <th
                            onClick={(e) =>
                              this.onSort(e, "client_profile__company_name")
                            }
                            className={!isClientPage ? "spanPointer" : "hide"}
                          >
                            {LBL_CLIENT}{" "}
                            <i
                              className={
                                sortField == "client_profile__company_name"
                                  ? getSortClass(1, sortOrder)
                                  : getSortClass()
                              }
                            ></i>
                          </th>
                          <th
                            onClick={(e) =>
                              this.onSort(e, "affiliate_profile__company_name")
                            }
                            className={
                              isClientPage ? "spanPointer sector" : "hide"
                            }
                          >
                            {LBL_AFFILIATE}{" "}
                            <i
                              className={
                                sortField == "affiliate_profile__company_name"
                                  ? getSortClass(1, sortOrder)
                                  : getSortClass()
                              }
                            ></i>
                          </th>
                          <th
                            onClick={(e) => this.onSort(e, "status")}
                            className="sub-sector spanPointer max-width-125 text-center"
                          >
                            {LBL_EVENT_STATUS}{" "}
                            <i
                              className={
                                sortField == "status"
                                  ? getSortClass(1, sortOrder)
                                  : getSortClass()
                              }
                            ></i>
                          </th>
                          <th className="date-join text-center">
                            {LBL_TEAM_COUNT}
                          </th>
                          <th
                            onClick={(e) => this.onSort(e, "shifts_count")}
                            className="last-login-date spanPointer text-center"
                          >
                            {LBL_SHIFT_COUNT}{" "}
                            <i
                              className={
                                sortField == "shifts_count"
                                  ? getSortClass(1, sortOrder)
                                  : getSortClass()
                              }
                            ></i>
                          </th>
                          <th
                          >
                            {LBL_Total_COST} ({LBL_CURRENCY_POUND}){" "}
                          </th>
                          {isQuoteSummary && (
                            <th>
                              {this.state.isEvent === 0
                                ? LBL_QUOTE
                                : LBL_QUOTE + "/" + LBL_INVOICE}
                            </th>
                          )}
                          <th>{LBL_PO}</th>
                          {this.props.location.pathname.includes("events") &&
                            !isClientPage &&
                            !isSuperAdminPage && <th>{LBL_SCHEDULE}</th>}
                          {!isSuperAdminPage && (
                            <th className="action">&nbsp;</th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.count === 0 && (
                          <tr>
                            <td colSpan="13" className="text-center">
                              {MSG_NOT_FOUND}
                            </td>
                          </tr>
                        )}
                        {events.map((item, index) => {
                          let indeNum =
                            PAGENUMROWS_AFFILIATE * (activePage - 1) +
                            index + 1;
                          const filteredStatus = eventStatus.filter(
                            (x) => Number(x.statusCode) === Number(item.status)
                          );

                          let quoteStatusValue = 1;
                          let shiftCount = item.shifts_count;

                          let filteredQuoteStatus = [];
                          if (item.quote_set.length > 0) {
                            quoteStatusValue = item.quote_set[0].quote_status;
                            filteredQuoteStatus = quoteStatus.filter(
                              (x) =>
                                Number(x.statusCode) ===
                                Number(quoteStatusValue)
                            );
                          }

                          let quoteStatusString = "";
                          let quoteStatusClass = "";
                          if (filteredQuoteStatus.length > 0) {
                            quoteStatusString =
                              isClientPage &&
                                filteredQuoteStatus[0].statusCode === QUOTE_SENT
                                ? filteredQuoteStatus[0].clientStatusString
                                : filteredQuoteStatus[0].statusString;
                            quoteStatusClass =
                              filteredQuoteStatus[0].colorClass;
                          }

                          let showRequestQuote =
                            is_active === true &&
                            showRequestQuoteBtn(
                              isClientPage,
                              Number(item.status),
                              quoteStatusValue
                            );
                          let showSendQuote =
                            is_active === true &&
                            showSendQuoteBtn(
                              isClientPage,
                              quoteStatusValue,
                              item.quote_number,
                              shiftCount,
                              item.status
                            );

                          let showSendInvoice =
                            is_active === true &&
                            showSendInvoiceBtn(isClientPage, item.status);

                          // FOR AFFILIATES ONLY, QUOTE CAN BE ACCEPTED IN STATUS - QUOTE_SENT, ESTIMATION & REESTIMATION - 30SEP2020
                          let showAcceptQuote = false;
                          if (!isClientPage)
                            showAcceptQuote = showAcceptRejectQuoteBtnAflt(
                              canAcceptQuote,
                              Number(item.status),
                              quoteStatusValue
                            );
                          else
                            showAcceptQuote =
                              is_active === true &&
                              showAcceptRejectQuoteBtn(
                                canAcceptQuote,
                                Number(item.status),
                                quoteStatusValue
                              );

                          let showRejectQuote =
                            is_active === true &&
                            showAcceptRejectQuoteBtn(
                              isClientPage,
                              Number(item.status),
                              quoteStatusValue
                            );
                          let showDownloadQuote = showDownloadQuoteBtn(
                            isClientPage,
                            Number(item.status),
                            item.quote_number,
                            shiftCount
                          );
                          let showCancelEvent =
                            is_active === true &&
                            showEventCancelBtn(
                              isClientPage,
                              Number(item.status)
                            );
                          let eventNotCancelled = checkEventNotCancelled(
                            Number(item.status)
                          );
                          let showSchedule =
                            is_active === true &&
                            showScheduleBtn(
                              isClientPage,
                              shiftCount,
                              Number(item.status)
                            );
                          let showComplete =
                            is_active === true &&
                            showCompleteEventBtn(isClientPage, item.status);

                          let locStartDate = converDateToLocal(
                            item.start_date,
                            "+00:00",
                            "ddmmyyyy"
                          );
                          let locEndDate = converDateToLocal(
                            item.end_date,
                            "+00:00",
                            "ddmmyyyy"
                          );

                          let eventSelData = this.state.isEvent
                            ? {
                              eventId: item.id,
                              fileType: "",
                              showSendInvoice: showSendInvoice,
                            }
                            : {
                              eventId: item.id,
                              fileType: "0",
                              showSendInvoice: showSendInvoice,
                            };
                          let tmpObj = eventSelOption.filter(
                            (eventItem) =>
                              Number(eventItem.eventId) === Number(item.id)
                          );
                          if (Array.isArray(tmpObj) && tmpObj.length)
                            eventSelData = tmpObj[0];

                          return (
                            <tr key={item.id}>
                              {/* <td>
                                            <div className="custom-checkbox"><input type="checkbox" id={"event-check"+item.id} /><label
                                                className="checkbox" htmlFor={"event-check"+item.id}></label></div>
                                        </td> */}
                              <td>{indeNum}</td>

                              <td>
                                <Link
                                  to="#"
                                  onClick={(e) =>
                                    this.showQuoteDetails(item.id)
                                  }
                                >
                                  {item.title}
                                </Link>
                                <br />
                                <small>
                                  {locStartDate + " - " + locEndDate}
                                </small>
                                {Number(EVENT_STATUS_COMPLETED) !==
                                  Number(item.status) && Number(EVENT_STATUS_INVOICED) !==
                                  Number(item.status) &&
                                  item.time_change_request === true && (
                                    <div className="text-danger mb-0">
                                      <small>
                                        {isClientPage
                                          ? LBL_TIME_CHANGE_REQUEST_CLIENT
                                          : LBL_TIME_CHANGE_REQUEST}
                                      </small>
                                    </div>
                                  )}
                              </td>

                              {isSuperAdminPage && (
                                <td>
                                  {item.affiliate_profile_details.company_name}
                                </td>
                              )}

                              <td className="text-center">
                                {item.quote_number === null
                                  ? MSG_NOT_GENERATED
                                  : item.quote_number}
                                <br />
                                <span className={quoteStatusClass}>
                                  <small className="status-fill">
                                    {quoteStatusString}
                                  </small>
                                </span>
                              </td>

                              <td>{item.location_detail.location.venue} </td>

                              <td className={!isClientPage ? "" : "hide"}>
                                <Link
                                  to={
                                    ROUTE_AFFILIATE_CLIENT_PROFILE +
                                    "/" +
                                    item.client_profile_details.id
                                  }
                                >
                                  {item.client_profile_details.company_name}
                                </Link>
                              </td>

                              <td className={isClientPage ? "" : "hide"}>
                                {item.affiliate_profile_details.company_name}
                              </td>

                              <td
                                className={
                                  filteredStatus[0].colorClass +
                                  " text-center min-width-125 max-width-125"
                                }
                              >
                                <small className="status-fill">
                                  {isClientPage &&
                                    filteredStatus[0].statusCode === QUOTE_SENT
                                    ? filteredStatus[0].clientStatusString
                                    : filteredStatus[0].statusString}
                                </small>
                                <p className="td-p">
                                  <small>{item.cancel_reason}</small>
                                </p>
                              </td>

                              <td className="text-center">
                                {item.team_count_assigned
                                  ? item.team_count_assigned
                                  : 0}
                                /
                                {item.team_count_total
                                  ? item.team_count_total
                                  : 0}
                              </td>

                              <td className="text-center">
                                {item.shifts_count}
                              </td>

                              <td className="">
                                <div className="div-right">{item.total}</div>
                              </td>

                              {isQuoteSummary && (
                                <td>
                                  <div className="form-group btn-group  mb-0">
                                    {this.state.isEvent > 0 &&
                                      isQuoteSummary && (
                                        <div className="select-input">
                                          <select
                                            name="fileType"
                                            defaultValue=""
                                            onChange={(e) =>
                                              this.quoteOrInvoice(
                                                e,
                                                item.id,
                                                showSendInvoice
                                              )
                                            }
                                          >
                                            <option value="">
                                              {LBL_SELECT}
                                            </option>
                                            <option value="0">
                                              {LBL_QUOTE}
                                            </option>
                                            {item.quote_number &&
                                              item.bot_sent_invoice && (
                                                <option value="1">
                                                  {LBL_INVOICE}
                                                </option>
                                              )}
                                          </select>
                                        </div>
                                      )}
                                    {/* {this.state.isEvent===0 && <div className="select-input"><select name="fileType" defaultValue="0" onChange={(e)=>this.quoteOrInvoice(e)}>
                                                    <option value="0">{LBL_QUOTE}</option>
                                                </select></div>} */}
                                    {(eventSelData.fileType !== "" && showDownloadQuote) && (
                                      <OverlayTrigger
                                        placement="top"
                                        delay={{ show: 250, hide: 400 }}
                                        overlay={
                                          <Tooltip
                                            id={item.id + "download-tooltip"}
                                            style={{
                                              opacity: 0.4,
                                            }}
                                          >
                                            {LBL_DOWNLOAD}
                                          </Tooltip>
                                        }
                                      >
                                        <button
                                          type="button"
                                          className="btn btn-outline-secondary ml-1"
                                          disabled={!showDownloadQuote}
                                          onClick={(e) =>
                                            this.quoteOrInvoiceDownload(
                                              e,
                                              item.id,
                                              eventSelData.fileType
                                            )
                                          }
                                        >
                                          <i className="las la-download"></i>
                                        </button>
                                      </OverlayTrigger>
                                    )}

                                    {!isSuperAdminPage &&
                                      showSendQuote &&
                                      eventSelData.fileType === "0" && (
                                        <OverlayTrigger
                                          placement="top"
                                          delay={{ show: 250, hide: 400 }}
                                          overlay={
                                            <Tooltip
                                              id={item.id + "sendQuote-tooltip"}
                                              style={{
                                                opacity: 0.4,
                                              }}
                                            >
                                              {LBL_SEND_QUOTE}
                                            </Tooltip>
                                          }
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-outline-secondary ml-1"
                                            onClick={(e) =>
                                              this.openSendQuoteModal(
                                                item.id,
                                                eventSelData.fileType
                                              )
                                            }
                                          >
                                            <i className="las la-share"></i>
                                          </button>
                                        </OverlayTrigger>
                                      )}

                                    {!isSuperAdminPage &&
                                      showSendInvoice &&
                                      eventSelData.fileType === "1" && (
                                        <OverlayTrigger
                                          placement="top"
                                          delay={{ show: 250, hide: 400 }}
                                          overlay={
                                            <Tooltip
                                              id={
                                                item.id + "sendInvoice-tooltip"
                                              }
                                              style={{
                                                opacity: 0.4,
                                              }}
                                            >
                                              {item.bot_sent_invoice ? LBL_RESEND_INVOICE : LBL_SEND_INVOICE}
                                            </Tooltip>
                                          }
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-outline-secondary ml-1"
                                            onClick={(e) =>
                                              this.openSendQuoteModal(
                                                item.id,
                                                eventSelData.fileType
                                              )
                                            }
                                          >
                                            <i className="las la-share"></i>
                                          </button>
                                        </OverlayTrigger>
                                      )}

                                    {showRequestQuote && !isSuperAdminPage && (
                                      <OverlayTrigger
                                        placement="top"
                                        delay={{ show: 250, hide: 400 }}
                                        overlay={
                                          <Tooltip
                                            id={item.id + "reQuote-tooltip"}
                                            style={{
                                              opacity: 0.4,
                                            }}
                                          >
                                            {LBL_REQUEST_QUOTE}
                                          </Tooltip>
                                        }
                                      >
                                        <button
                                          type="button"
                                          className="btn btn-outline-secondary ml-1"
                                          onClick={(e) =>
                                            this.openRequestQuoteModal(item.id)
                                          }
                                        >
                                          <i className="las la-reply"></i>
                                        </button>
                                      </OverlayTrigger>
                                    )}
                                  </div>
                                </td>
                              )}

                              <td>
                                {item.po_number === null ? "" : item.po_number}
                              </td>
                              {this.props.location.pathname.includes(
                                "events"
                              ) &&
                                !isClientPage &&
                                !isSuperAdminPage && (
                                  <td>
                                    {eventNotCancelled &&
                                      showSchedule &&
                                      isViewSchedule && (
                                        <Link
                                          to={
                                            ROUTE_AFFILIATE_SCHEDULE_SHIFT +
                                            "/" +
                                            item.id
                                          }
                                        >
                                          <i
                                            className="lar la-clock pl-3"
                                            style={{ fontSize: "24px" }}
                                          ></i>
                                        </Link>
                                      )}
                                  </td>
                                )}
                              {(!isSuperAdminPage && !isClientPage) && (
                                <td>
                                  {eventNotCancelled && is_active === true && (
                                    <div
                                      className="dropdown"
                                      id={"dropdown-" + item.id}
                                    >
                                      <button
                                        className="dropdown-toggle"
                                        type="button"
                                        id={"dropdownMenuButton-" + item.id}
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        onClick={(e) =>
                                          this.onShowActionButtons(e, item.id)
                                        }
                                      >
                                        {/* <img id={"img-action-"+item.id} src={require('../../'+URL_IMG+'action.png')} alt="Action" /> &nbsp;  */}
                                        <input
                                          type="image"
                                          id={"img-action-" + item.id}
                                          src={require("../../" +
                                            URL_IMG +
                                            "action.png")}
                                          alt="Action"
                                          onBlur={(e) =>
                                            this.onHideActionButtons(e, item.id)
                                          }
                                        ></input>
                                      </button>

                                      <div
                                        className="dropdown-menu"
                                        id={"dropdown-menu-" + item.id}
                                        aria-labelledby={
                                          "dropdownMenuButton-" + item.id
                                        }
                                      >
                                        {showRequestQuote && (
                                          <Link
                                            className="dropdown-item edit"
                                            to="#"
                                            onMouseDown={(e) =>
                                              this.openRequestQuoteModal(
                                                item.id
                                              )
                                            }
                                          >
                                            {LBL_REQUEST_QUOTE}
                                          </Link>
                                        )}

                                        {showSendQuote && (
                                          <Link
                                            className="dropdown-item edit"
                                            to="#"
                                            onMouseDown={(e) =>
                                              this.openSendQuoteModal(
                                                item.id,
                                                "0"
                                              )
                                            }
                                          >
                                            {LBL_SEND_QUOTE}
                                          </Link>
                                        )}

                                        {showSendInvoice && (
                                          <Link
                                            className="dropdown-item edit"
                                            to="#"
                                            onMouseDown={(e) =>
                                              this.openSendQuoteModal(
                                                item.id,
                                                "1"
                                              )
                                            }
                                          >
                                            {item.bot_sent_invoice ? LBL_RESEND_INVOICE : LBL_SEND_INVOICE}
                                          </Link>
                                        )}

                                        {/* IF PO NUMBER NOT ADDED, ADD PO NUMBER AND ACCEPT QUOTE */}
                                        {Number(item.shifts_count) > 0 &&
                                          showAcceptQuote &&
                                          item.po_number === null && (
                                            <Link
                                              className="dropdown-item edit"
                                              to="#"
                                              onMouseDown={(e) =>
                                                this.openQuoteAcceptModal(
                                                  item.id
                                                )
                                              }
                                            >
                                              {LBL_ACCEPT_QUOTE}
                                            </Link>
                                          )}

                                        {Number(item.shifts_count) > 0 &&
                                          showAcceptQuote &&
                                          item.po_number !== null && (
                                            <Link
                                              className="dropdown-item edit"
                                              to="#"
                                              onMouseDown={(e) =>
                                                this.openQuoteAcceptModalWithPO(
                                                  item.id,
                                                  item.po_number
                                                )
                                              }
                                            >
                                              {LBL_ACCEPT_QUOTE}
                                            </Link>
                                          )}

                                        {Number(EVENT_STATUS_INVOICED) != Number(item.status) && !item.bot_sent_invoice && isAddQuote && (
                                          <Link
                                            className="dropdown-item edit"
                                            to="#"
                                            onMouseDown={(e) =>
                                              this.eventEditBtnClick(
                                                item.id,
                                                item.client_profile
                                              )
                                            }
                                          >
                                            {LBL_EDIT}
                                          </Link>
                                        )}
                                        {showComplete && (
                                          <Link
                                            className="dropdown-item edit"
                                            to="#"
                                            onMouseDown={(e) =>
                                              this.onEventCompletion(item.id)
                                            }
                                          >
                                            {LBL_COMPLETE}
                                          </Link>
                                        )}

                                        {showRejectQuote && (
                                          <Link
                                            className="dropdown-item delete"
                                            to="#"
                                            onMouseDown={(e) =>
                                              this.openRejectQuoteModal(item.id)
                                            }
                                          >
                                            {LBL_REJECT_QUOTE}
                                          </Link>
                                        )}

                                        {showCancelEvent && (
                                          <Link
                                            className="dropdown-item delete"
                                            to="#"
                                            onMouseDown={(e) =>
                                              this.openEventCancelModal(item.id)
                                            }
                                          >
                                            {LBL_DECLINE}
                                          </Link>
                                        )}

                                        {/* <Link className="dropdown-item delete"
                                                to="#" onMouseDown={(e)=>this.deleteBtnClick(item.id,item.title)}>Delete</Link> */}

                                        {showSchedule && isViewSchedule && (
                                          <Link
                                            className="dropdown-item edit"
                                            to="#"
                                            onMouseDown={(e) =>
                                              this.scheduleShiftClick(item.id)
                                            }
                                          >
                                            {LBL_SCHEDULE_SHIFT}
                                          </Link>
                                        )}
                                        {showSendInvoice && (
                                          <Link
                                            className="dropdown-item edit"
                                            to="#"
                                            onMouseDown={(e) =>
                                              this.onEventInvoiceCSVDownload(
                                                item.id
                                              )
                                            }
                                          >
                                            {LBL_EXPORT_INVOICE}
                                          </Link>
                                        )}
                                      </div>

                                    </div>
                                  )}
                                </td>
                              )}
                              {(isClientPage) && (
                                <td>
                                  {eventNotCancelled && is_active === true && (


                                    <div className="d-flex">

                                      {/* {showRequestQuote && (
                                          <Link
                                            className="btn btn-primary text-nowrap"
                                            to="#"
                                            onMouseDown={(e) =>
                                              this.openRequestQuoteModal(
                                                item.id
                                              )
                                            }
                                          >
                                            {LBL_REQUEST_QUOTE}
                                          </Link>
                                        )} */}

                                      {showSendQuote && (
                                        <Link
                                          className="btn btn-primary text-nowrap"
                                          to="#"
                                          onMouseDown={(e) =>
                                            this.openSendQuoteModal(
                                              item.id,
                                              "0"
                                            )
                                          }
                                        >
                                          {LBL_SEND_QUOTE}
                                        </Link>
                                      )}

                                      {showSendInvoice && (
                                        <Link
                                          className="btn btn-primary text-nowrap"
                                          to="#"
                                          onMouseDown={(e) =>
                                            this.openSendQuoteModal(
                                              item.id,
                                              "1"
                                            )
                                          }
                                        >
                                          {item.bot_sent_invoice ? LBL_RESEND_INVOICE : LBL_SEND_INVOICE}
                                        </Link>
                                      )}

                                      {/* IF PO NUMBER NOT ADDED, ADD PO NUMBER AND ACCEPT QUOTE */}
                                      {Number(item.shifts_count) > 0 &&
                                        showAcceptQuote &&
                                        item.po_number === null && (
                                          <Link
                                            className="btn btn-primary text-nowrap"
                                            to="#"
                                            onMouseDown={(e) =>
                                              this.openQuoteAcceptModal(
                                                item.id
                                              )
                                            }
                                          >
                                            {LBL_ACCEPT_QUOTE}
                                          </Link>
                                        )}

                                      {Number(item.shifts_count) > 0 &&
                                        showAcceptQuote &&
                                        item.po_number !== null && (
                                          <Link
                                            className="btn btn-primary text-nowrap"
                                            to="#"
                                            onMouseDown={(e) =>
                                              this.openQuoteAcceptModalWithPO(
                                                item.id,
                                                item.po_number
                                              )
                                            }
                                          >
                                            {LBL_ACCEPT_QUOTE}
                                          </Link>
                                        )}

                                      {isAddQuote && (
                                        <Link
                                          className="btn btn-outline-secondary ml-1"
                                          to="#"
                                          onMouseDown={(e) =>
                                            this.eventEditBtnClick(
                                              item.id,
                                              item.client_profile
                                            )
                                          }
                                        >
                                          <i className="las la-pen"></i>
                                        </Link>
                                      )}



                                      {showComplete && (
                                        <Link
                                          className="btn btn-primary text-nowrap"
                                          to="#"
                                          onMouseDown={(e) =>
                                            this.onEventCompletion(item.id)
                                          }
                                        >
                                          {LBL_COMPLETE}
                                        </Link>
                                      )}

                                      {showRejectQuote && (
                                        <Link
                                          style={{ color: "red", cursor: "pointer", marginLeft: "10px", display: "flex", alignItems: 'center' }}
                                          className="text-nowrap "
                                          to="#"
                                          onMouseDown={(e) =>
                                            this.openRejectQuoteModal(item.id)
                                          }
                                        >
                                          {LBL_REJECT_QUOTE}
                                        </Link>
                                      )}

                                      {showCancelEvent && (
                                        <Link
                                          style={{ color: "red", cursor: "pointer", marginLeft: "10px", display: "flex", alignItems: 'center' }}
                                          className="text-nowrap "
                                          to="#"
                                          onMouseDown={(e) =>
                                            this.openEventCancelModal(item.id)
                                          }
                                        >
                                          {LBL_CANCEL}
                                        </Link>
                                      )}

                                      {/* <Link className="dropdown-item delete"
                                                to="#" onMouseDown={(e)=>this.deleteBtnClick(item.id,item.title)}>Delete</Link> */}

                                      {showSchedule && isViewSchedule && (
                                        <Link
                                          className="btn btn-primary text-nowrap"
                                          to="#"
                                          onMouseDown={(e) =>
                                            this.scheduleShiftClick(item.id)
                                          }
                                        >
                                          {LBL_SCHEDULE_SHIFT}
                                        </Link>
                                      )}
                                      {showSendInvoice && (
                                        <Link
                                          className="btn btn-primary text-nowrap"
                                          to="#"
                                          onMouseDown={(e) =>
                                            this.onEventInvoiceCSVDownload(
                                              item.id
                                            )
                                          }
                                        >
                                          {LBL_EXPORT_INVOICE}
                                        </Link>
                                      )}
                                    </div>

                                  )}
                                </td>
                              )}
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                    <Paginator
                      totalPage={totalPage}
                      activePage={activePage}
                      startIndex={startIndex}
                      endIndex={endIndex}
                      onPagePrevious={this.onPagePrevious}
                      onPageUp={this.onPageUp}
                      onPageNext={this.onPageNext}
                    />
                    <div className="clear-b-scroll-sector">&nbsp;</div>
                    <div className="clear-b-scroll-sector">&nbsp;</div>
                    <div className="clear-b-scroll-sector">&nbsp;</div>
                  </div>
                </>
              )}
              {!isListLayout && (
                <>
                  <EventCalendarView
                    showQuoteDetails={this.showQuoteDetails}
                    {...this.state}
                    timeZone={timeZone}
                  />
                </>
              )}
            </div>
          </div>
          <ModalWindow
            ref={this.modalQuoteDelete}
            header={LBL_CONFIRM_DELETE}
            type="delete"
            deleteItem={this.onDeleteAction}
            resetModalForm={this.onModalFormReset}
          >
            {"Are you sure you want to delete the event '" +
              this.state.eventDeleteTitle +
              "' ?"}
          </ModalWindow>

          <ModalWindow
            ref={this.modalEventCancel}
            header="Confirm Cancel/Decline Event"
            type="confirm"
            deleteConfirmedItem={this.onCancelAction}
            resetModalForm={this.onModalFormReset}
          >
            {MSG_CANCEL_EVENT_CONFIRM}
            <div className="form-group select-input max-width-50 marginTop15">
              <select
                name="cancelReason"
                onChange={(e) => this.onHandleReasonChange(e)}
                value={this.state.cancelReasonId}
                className={this.state.cancelReasonId ? "" : "input-error"}
              >
                <option value="">{LBL_SELECT}</option>
                {this.props.cancelReasons &&
                  Array.isArray(this.props.cancelReasons) &&
                  this.props.cancelReasons.map((item, index) => {
                    return <option key={item.id} value={item.id}>{item.name}</option>;
                  })}
              </select>
            </div>
          </ModalWindow>

          <ModalWindow
            ref={this.modalQuote}
            header={
              <CustomModalHeaderStepper activeStep={1} />
            }
            saveFormData={(e) => this.onSaveFormData(e)}
            resetModalForm={this.onModalFormReset}
            type="save"
            className="custom-modal "
            stepper={true}
          >
            <EventAdd
              refreshClientList={this.refreshClientList}
              defaultStartDate={this.state.defaultStartDate}
              clients={clients}
              clientContacts={clientContacts}
              locations={locations}
              affiliateList={affiliateList}
              onsearchLocation={this.onSearchLocation}
              onSelectLocation={(e) => this.onSelectLocation(e)}
              onHandleChange={(e) => this.onHandleChange(e)}
              onStartDateChange={(e) => this.onStartDateChange(e)}
              onEndDateChange={(e) => this.onEndDateChange(e)}
              onStartTimeChange={(e) => this.onStartTimeChange(e)}
              onStartTimeBlur={(e) => this.onStartTimeBlur(e)}
              onEndTimeChange={(e) => this.onEndTimeChange(e)}
              onEndTimeBlur={(e) => this.onEndTimeBlur(e)}
              {...this.state}
              onGetGoogleLoc={(e) => this.onGetGoogleLoc(e)}
              googleLocSelect={(e) => this.googleLocSelect(e)}
              handleClientContactChange={this.handleClientContactChange}
              handleRemoveContact={this.handleRemoveContact}
              handleClientChange={this.handleClientChange}
              handleRemoveClient={this.handleRemoveClient}
              resetGoogleLocation={this.state.resetGoogleLocation}
              validationMsgArr={this.state.validationMsgArr}
            />
          </ModalWindow>

          <ShiftAdd
            ref={this.shiftRef}
            onsearchLocation={this.onSearchLocation}
            reloadEventList={this.reloadEventList}
            {...this.state}
            calledFrom="eventList"
            callEventDetailsWithPreviewQuote={
              this.callEventDetailsWithPreviewQuote
            }
            openAddClientContact={this.openAddClientContact}
            isClientPage={isClientPage}
          />

          <ModalWindow
            ref={this.modalAcceptQuoteWithPO}
            header={LBL_ACCEPT_QUOTE}
            type="confirm"
            deleteConfirmedItem={this.onAcceptActionWithPO}
            resetModalForm={this.onModalFormReset}
            className={"zIndex-999999"}
          >
            {isClientPage
              ? MSG_CONFIRM_ACCEPT_QUOTE
              : MSG_CONFIRM_ACCEPT_QUOTE_AFLT}
          </ModalWindow>

          <ModalWindow
            ref={this.modalAcceptQuote}
            header={LBL_ACCEPT_QUOTE}
            resetModalForm={this.onModalFormReset}
            type="formSubmit"
            saveSign={isClient ? this.saveSign : ""}
            className={"zIndex-999999"}
          >
            <Form
              id="form_dataEntry"
              onSubmit={(e) => this.onAcceptAction(e)}
              encType="multipart/form-data"
            >
              <Form.Group>
                {isClient && (
                  <div className="col-md-12 item-align-center">
                    <p className={"text-red logo-txt"}>
                      <small>{this.state.labelValidation}</small>
                    </p>
                  </div>
                )}
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>{LBL_PO} </label>
                      <div className={"text-input"}>
                        <input
                          type="text"
                          placeholder=""
                          name="acceptQuotePONumber"
                          onChange={this.onHandleChange}
                          className={
                            this.state.formErrors.acceptQuotePONumber &&
                              this.state.formErrors.acceptQuotePONumber.length > 0
                              ? "input-error"
                              : ""
                          }
                          value={this.state.acceptQuotePONumber}
                        />
                      </div>
                    </div>
                  </div>
                  {isClient && (
                    <div className="col-md-12 item-align-center">
                      <label> OR </label>
                    </div>
                  )}
                </div>
                {isClient && (
                  <div className="row">
                    <div className="col-md-12 item-align-center">
                      <div className="col-md-12 item-align-center">
                        <label>Authorized Signatory For Quotes</label>
                      </div>
                      <div
                        className="company-logo"
                        style={{
                          marginLeft: "10px",
                          marginRight: "10px",
                          marginTop: "10px",
                          marginBottom: "10px",
                        }}
                      >
                        <img
                          src={signatureLogoUrl}
                          alt="Signature"
                          style={{
                            width: "200px",
                            height: "auto",
                            borderRadius: "1px",
                          }}
                        />
                        <p
                          className={
                            isSignatureValid
                              ? "logo-txt mb-0"
                              : "text-red logo-txt"
                          }
                        >
                          <small>{signatureLabel}</small>
                        </p>
                        <label
                          htmlFor="uploadSignature"
                          style={{ top: "-18px", right: "-14px" }}
                        >
                          <i className="las la-pen"></i>
                        </label>
                        <input
                          type="file"
                          id="uploadSignature"
                          name="signature"
                          onChange={this.onHandleChange}
                          accept=".jpeg, .jpg, .png, .gif"
                        />
                      </div>
                    </div>
                  </div>
                )}
              </Form.Group>
            </Form>
          </ModalWindow>

          <ModalWindow
            ref={this.modalSendQuote}
            className="zIndex-999999"
            header={
              Number(this.state.fileType) > 0
                ? (LBL_SEND_INVOICE)
                : LBL_SEND_QUOTE
            }
            type="confirm"
            deleteConfirmedItem={this.onSendQuoteAction}
            resetModalForm={this.onModalFormReset}
          >
            {Number(this.state.fileType) > 0
              ? MSG_CONFIRM_SEND_INVOICE
              : MSG_CONFIRM_SEND_QUOTE}
          </ModalWindow>

          <ModalWindow
            ref={this.modalRejectQuote}
            header="Reject Quote"
            type="confirm"
            deleteConfirmedItem={this.onRejectQuoteAction}
            resetModalForm={this.onModalFormReset}
          >
            {LBL_CONFIRM_REJECT_QUOTE}
          </ModalWindow>

          <ModalWindow
            ref={this.modalRequestQuote}
            header="Request Quote"
            type="confirm"
            deleteConfirmedItem={this.onRequestQuoteAction}
            resetModalForm={this.onModalFormReset}
          >
            <div className="text-bold">{LBL_SEND_QUOTE_REQUEST_NOTE}</div>
            <div>{LBL_CONFIRM_SEND_QUOTE_REQUEST}</div>
          </ModalWindow>

          <ModalWindow
            ref={this.modalEventComplete}
            header="Complete Event"
            type="confirm"
            deleteConfirmedItem={this.onEventCompleteAction}
            resetModalForm={this.onModalFormReset}
          >
            {LBL_CONFIRM_EVENT_COMPLETE}
          </ModalWindow>

          <ModalWindow
            modalId="contactModalPop"
            ref={this.contactModal}
            header={LBL_ADD_NEW_CLIENT_CONTACT}
            saveFormData={(e) => this.onSaveFormClientContactData(e)}
            resetModalForm={this.onModalClientContactFormReset}
            type="save"
          >
            <ClientContactAdd
              saveFormDataClicked={this.state.saveFormDataClicked}
              newClientContactAdded={this.state.newClientContactAdded}
              refreshParent={this.refreshParent}
              clientId={this.state.eventDataForShift.clientId}
              setToasterStatePop={this.setToasterStatePop}
              addContactClicked={this.state.addContactClicked}
            ></ClientContactAdd>
          </ModalWindow>
        </div>

        <Filter
          isDetail={true}
          onResetFiltersButton={this.onResetFiltersButton}
          onApplyFilterButton={this.onApplyFilterButton}
          needParentCallBack="yes"
          onFilterClose={this.onFilterClose}
        >
          <FilterQuote
            cancelReasons={this.props.cancelReasons}
            filterClicked={this.state.filterClicked}
            onApplyFilterButton={this.onApplyFilterButton}
            resetFilterClicked={this.state.resetFilterClicked}
            applyFilterClicked={this.state.applyFilterClicked}
            applyFilters={this.applyFilters}
            isEvent={this.state.isEvent}
            isClientPage={this.state.isClientPage}
            clientId={this.state.eventData.clientId}
            isListLayout={this.state.isListLayout}
            userGroup={userGroup}
          />

          <EventDetails
            activeTab={this.state.activeTab}
            onsearchLocation={this.onSearchLocation}
            setToasterState={this.setToasterState}
            {...this.state}
            reloadQuoteDetails={this.reloadQuoteDetails}
            eventEditBtnClick={this.eventEditBtnClick}
            openEventDeleteModal={this.openEventDeleteModal}
            onTabChangeSet={this.onTabChangeSet}
            userGroup={this.state.userGroup}
            openEventCancelModal={this.openEventCancelModal}
            {...this.state}
            location={this.props.location}
            openQuoteAcceptModal={this.openQuoteAcceptModal}
            openQuoteAcceptModalWithPO={this.openQuoteAcceptModalWithPO}
            openSendQuoteModal={this.openSendQuoteModal}
            openRejectQuoteModal={this.openRejectQuoteModal}
            openRequestQuoteModal={this.openRequestQuoteModal}
            onEventCompletion={this.onEventCompletion}
            needparentCallback="yes"
            onEventDetailsClose={this.onEventDetailsClose}
            is_active={is_active}
            showShiftDetails={this.showShiftDetails}
          />

          <ShiftDetailSlider
            location={this.props.location}
            activeShiftId={this.state.activeShiftId}
            hideEditDeleteAction="1"
            calledFrom="eventsList"
            shiftScheduleListAction={this.props.shiftScheduleListAction}
            paramId={this.props.match.params.id}
            loadEventSchedule={this.loadEventSchedule}
            showActiveEventDetails={this.showActiveEventDetails}
            isClientPage={isClientPage}
          />
        </Filter>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    downloadEvents: state.event.downloadEvents,
    downloadStatus: state.event.downloadStatus,
    downloadActivity: state.event.downloadActivity,
    invoiceDownloadEvents: state.event.invoiceDownloadEvents,
    invoiceDownloadStatus: state.event.invoiceDownloadStatus,
    invoiceDownloadActivity: state.event.invoiceDownloadActivity,
    events: state.event.events,
    eventData: state.event.item,
    totalPage: state.event.totalPage,
    status: state.event.status,
    activity: state.event.activity,
    subactivity: state.event.activity,
    numRows: state.event.numRows,
    count: state.event.count,
    errorData: state.event.errorData,
    clients: state.event.clients,
    clientContacts: state.event.clientContacts,
    locations: state.event.locations,
    clientSignature: state.event.signature,
    affiliateList: state.event.affiliateList,
    isFilterOn: state.commons.isFilterOn,
    eventId: state.event.eventId,
    eventPopupId: state.event.eventPopupId,
    cancelReasons: state.event.cancelReasons,
    validateResponse: state.validate.validateResponse,
    validateStatus: state.validate.validateStatus,
    validateActivity: state.validate.validateActivity,
    validateErrorData: state.validate.validateErrorData,
    popUpModal: state.commons.fromDashboard,
    dashboardActionRequired: state.commons.fromActionRequired,
    serverTimeList: state.serverTimeList.serverTimeList,
    serverTimeListActivity: state.serverTimeList.serverTimeListActivity,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      eventListAction: eventListAction,
      eventClientListAction: eventClientListAction,
      clientContactListAction: clientContactListAction,
      quoteEventLocationListAction: quoteEventLocationListAction,
      eventAddAction: eventAddAction,
      eventEditAction: eventEditAction,
      eventUpdateAction: eventUpdateAction,
      eventDeleteAction: eventDeleteAction,
      eventQuoteSummaryAction: eventQuoteSummaryAction,
      eventSummaryAction: eventSummaryAction,
      eventClientDetailsAction: eventClientDetailsAction,
      eventUserLogsListAction: eventUserLogsListAction,
      quoteAcceptAction: quoteAcceptAction,
      quoteRejectAction: quoteRejectAction,
      quoteRequestAction: quoteRequestAction,
      eventClientAffiliateListAction: eventClientAffiliateListAction,
      quoteSendtoClientAction: quoteSendtoClientAction,
      invoiceSendtoClientAction: invoiceSendtoClientAction,
      quoteDownloadAction: quoteDownloadAction,
      invoiceDownloadAction: invoiceDownloadAction,
      eventCancelAction: eventCancelAction,
      eventPopupIdResetAction: eventPopupIdResetAction,
      validateEventAddAction: validateEventAddAction,
      eventCompleteAction: eventCompleteAction,
      clearAction: clearAction,
      fromDashboard: fromDashboard,
      eventListDownloadAction: eventListDownloadAction,
      invoiceListDownloadAction: invoiceListDownloadAction,
      listEventShiftsAction: listEventShiftsAction,
      listEventMessagesAction: listEventMessagesAction,
      listInvoiceAction: listInvoiceAction,
      aflt_departmentsListAction: aflt_departmentsListAction,
      cancelReasonsListAction: cancelReasonsListAction,
      sendShiftIdsForScheduleAction: sendShiftIdsForScheduleAction,
      serverTimeAction: serverTimeAction,
    },
    dispatch
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(EventList);
